hmi.utils.insert_module({
    name: 'pipe',
    instance: null,
    groupType: hmi.constant.groupType.pipe,
    type: hmi.constant.PIPE,
    svgName: 'pipeh',
});

hmi.utils.load_svg_symbol('assets/images/hmiCommponents/pipeh.svg', hmi.symbols, 'svgPipeLine');
hmi.utils.load_svg_symbol('assets/images/hmiCommponents/pipev.svg', hmi.symbols, 'svgPipeLineV');
hmi.utils.load_svg_symbol('assets/images/hmiCommponents/pipe-unionBR.svg', hmi.symbols, 'svgPipeUnionBR');
hmi.utils.load_svg_symbol('assets/images/hmiCommponents/pipe-unionLB.svg', hmi.symbols, 'svgPipeUnionLB');
hmi.utils.load_svg_symbol('assets/images/hmiCommponents/pipe-unionTR.svg', hmi.symbols, 'svgPipeUnionTR');
hmi.utils.load_svg_symbol('assets/images/hmiCommponents/pipe-unionLT.svg', hmi.symbols, 'svgPipeUnionLT');

hmi.models.pipe = function () {
    "use strict";

    //============================================================
    // Public Variables with Default Settings
    //------------------------------------------------------------
    var showMode = hmi.constant.showMode.monitor,
        signal = hmi.constant.signals.conection,
        designMode = false,
        availableWidth,
        availableHeight,
        valueFormat = d3.format(',.3f');

    //============================================================
    // Private Variables
    //------------------------------------------------------------


    var allData = [],
        type = hmi.constant.PIPE,
        groupType = hmi.constant.groupType.pipe,
        isInitialize = false,
        selectTarget,
        dragPipeBehavior,
        dragTargetId,
        dispatch = d3.dispatch('componentChange', 'pendingPipeChange', 'addCompletePipe', 'selectElement'),
        pendingPipe,
        svgPipeLine,
        svgPipeLineV,
        svgPipeUnionBR,
        svgPipeUnionTR,
        svgPipeUnionLB,
        svgPipeUnionLT,
        color = {
            normal: '#a0a0a0',
            select: '#0000a0',
            hover: '#0000e0'
        },
        pipeColor = '#a00000',
        defaultWidth = 25,
        defaultHeight = 25,
        componentWidth = 75,
        componentHeight = 75,
        componentPipePosition = 25,
        componentPipeVPosition = 55,
        pipeOffset = 7,
        pipeUnionPosition = 15,
        pipeUnionWidth = 40,
        pipeUnionHeight = 40,
        pipeSize = 1;

    // todo this is temporal the position will come from component
    var tracerMode = {
        link1: hmi.constant.pipeCPosition.R,
        link2: hmi.constant.pipeCPosition.L
    };

    function getPipeUnionPosition(d) {
        return pipeUnionPosition * d.pipeSize;
    }

    function getPipeUnionWidth(d) {
        return pipeUnionWidth * d.pipeSize;
    }

    function getPipeUnionHeight(d) {
        return pipeUnionHeight * d.pipeSize;
    }

    function getDefaultWidth(d) {
        var pipeSizeTemp = d.pipeSize || pipeSize;
        return defaultWidth * pipeSizeTemp;
    }

    function getDefaultHeight(d) {
        var pipeSizeTemp = d.pipeSize || pipeSize;
        return defaultHeight * pipeSizeTemp;
    }

    function colorFill(d) {
        return d.pipeColor;
    }

    function colorFillOpacity(d) {
        return d.pipeColor ? hmi.constant.opacity : 0;
    }

    function pipeColorFill(d) {
        var parent = d3.select('g#' + d.parentId);
        // var parent = d3.select('g#' + d.id);
        parent.selectAll('.PIPEH_background')
            .attr('fill', function () {
                return colorFill(d);
            })
            .style('opacity', function () {
                return colorFillOpacity(d);
            });
        parent.selectAll('.PIPEV_background')
            .attr('fill', function () {
                return colorFill(d);
            })
            .style('opacity', function () {
                return colorFillOpacity(d);
            });
        parent.selectAll('.PIPEUNIONBR_background')
            .attr('fill', function () {
                return colorFill(d);
            })
            .style('opacity', function () {
                return colorFillOpacity(d);
            });
        parent.selectAll('.PIPEUNIONLB_background')
            .attr('fill', function () {
                return colorFill(d);
            })
            .style('opacity', function () {
                return colorFillOpacity(d);
            });
        parent.selectAll('.PIPEUNIONLT_background')
            .attr('fill', function () {
                return colorFill(d);
            })
            .style('opacity', function () {
                return colorFillOpacity(d);
            });
        parent.selectAll('.PIPEUNIONTR_background')
            .attr('fill', function () {
                return colorFill(d);
            })
            .style('opacity', function () {
                return colorFillOpacity(d);
            });
    }

    var initializeCanvasObjects = function (gComponent, gEnter) {

        gComponent.append('g')
            .attr('class', 'hmi-parts-pipes');

        var pipeEnter = gEnter.select('g.hmi-parts-pipes')
            .selectAll('g.part-pipes')
            .data(function (d) {
                return d.components;
            }, function (item) {
                return item.key;
            });

        pipeEnter.enter()
            .append('g')
            .attr('class', 'part-pipes')
            .html(function (d) {
                switch (d.pipeType) {
                    case hmi.constant.pipeType.line:
                        if (d.alignment === hmi.constant.alignment.horizontal) {
                            return svgPipeLine;
                        } else {
                            return svgPipeLineV;
                        }
                        break;
                    case hmi.constant.pipeType.unionLB:
                        return svgPipeUnionLB;
                    case hmi.constant.pipeType.unionLT:
                        return svgPipeUnionLT;
                    case hmi.constant.pipeType.unionTR:
                        return svgPipeUnionTR;
                    case hmi.constant.pipeType.unionBR:
                        return svgPipeUnionBR;
                }

            })
            .on('click', function () {
                hmi.utils.unSelectComponent();
                if (showMode === hmi.constant.showMode.match ||
                    showMode === hmi.constant.showMode.design) {
                    selectTarget = this.parentNode.parentNode;
                    selectComponent();
                    dispatch.selectElement({
                        component: d3.select(selectTarget).attr('id'),
                        signal: signal
                    });
                }

            })
            .on({
                'mouseover': function (d) {
                    if (showMode === hmi.constant.showMode.design) {
                        if (d.movable) {
                            d3.select(this).style('cursor', 'move');
                        }
                    }
                }
            });
        // .on({
        //     'mouseout': function (d) {
        //         if (showMode === hmi.constant.showMode.design) {
        //             if (d.movable) {
        //                 d3.select(this)
        //                     .style('stroke', null);
        //             }
        //         }
        //     }
        // })
        pipeEnter.call(dragPipeBehavior);

        pipeEnter
            .attr('transform', function (d) {
                pipeColorFill(d);
                if (d.transform) {
                    return d.transform;
                }
            });
        // pipeItem

        pipeEnter.exit().remove();
    };

    var addSubComponents = function (d, data) {
        var result = null;
        if (!data) {
            result = {
                id: d.id + '-sub-' + (d.components.length + 1),
                key: d.id + '-sub-' + (d.components.length + 1),
                index: d.components.length,
                type: type,
                groupType: groupType,
                pipeType: hmi.constant.pipeType.line,
                width: null,
                height: null,
                transformWidth: null,
                transformHeight: null,
                x: d.x,
                y: d.y,
                html: null,
                transform: null,
                pipeColor: d.pipeColor,
                pipeSize: d.pipeSize,
                movable: d.movable,
                parentId: d.id,
                alignment: hmi.constant.alignment.horizontal
            };
        } else {
            result = {
                id: data.id,
                key: data.key,
                index: data.index,
                alias: data.alias,
                type: data.type,
                groupType: data.groupType,
                pipeType: data.pipeType,
                width: data.width,
                height: data.height,
                x: data.x,
                y: data.y,
                html: data.html,
                pipeColor: data.pipeColor || null,
                pipeSize: data.pipeSize || pipeSize,
                movable: data.movable,
                transform: data.transform,
                parentId: data.parentId,
                alignment: data.alignment
            };
        }

        return result;
    };

    dragPipeBehavior = d3.behavior.drag()
        .on('dragstart', function (d, i) {
            d3.event.sourceEvent.stopPropagation();
            if (showMode === hmi.constant.showMode.design) {
                if (d.movable) {
                    d3.select(this).style('cursor', 'move');
                    d3.select(this)
                        .style('stroke', color.hover);
                    dragTargetId = d.parentId;
                }
            }
            // if (dragTarget && showMode === hmi.constant.showMode.design) {
            //     dragSubComponentTarget.attr("pointer-events", "none");
            // }
        })
        .on('drag', function (d, i) {
            if (dragTargetId && showMode === hmi.constant.showMode.design) {
                var item = allData.find(function (element) {
                    return element.id === dragTargetId;
                });
                // if(event.y < 100){
                //
                // }

                //var offset = {index: d.index, x: event.x, y: event.y};
                var offset = { index: d.index, x: d3.event.x, y: d3.event.y };

                item = pipeTracer(item, item.pipeTracerMode, offset);
                dispatch.componentChange({
                    component: item
                });
            }

            // if (dragSubComponentTarget && showMode === hmi.constant.showMode.design) {
            //     var eventX = event.x;
            //     var eventY = event.y;
            //     var component = null;
            //     var componentIndex = allData.findIndex(function (element) {
            //         return element.components[subComponent.alias].id === selectTargetId;
            //     });
            //     if (componentIndex !== -1) {
            //         component = allData[componentIndex];
            //         component.components[subComponent.alias].x = eventX;
            //         component.components[subComponent.alias].y = eventY;
            //         transformAliasPosition(component.components[subComponent.alias].id, component, component.components[subComponent.alias]);
            //     }
            // }
        })
        .on('dragend', function (d, i) {
            d3.select(this).attr("pointer-events", "all")
                .style('stroke', null);
            d3.event.sourceEvent.stopPropagation();
        });

    var pipeTrace = function (d) {
        //d.links = { link1: d.link1, link2: d.link2 };
        // get the pipe model tracer
        var pipeTracerMode = getPipeTracer(d.links);
        // tracer
        return pipeTracer(d, pipeTracerMode);
    };

    // update links to right position
    var fillLinks = function (link1Item, link2Item) {
        var result = { link1: link1Item, link2: link2Item };
        result.link1.x = Number(result.link1.attr('x'));
        result.link1.y = Number(result.link1.attr('y'));
        result.link2.x = Number(result.link2.attr('x'));
        result.link2.y = Number(result.link2.attr('y'));
        return result;
    };

    // get the pipe model tracer
    var getPipeTracer = function (links) {
        //
        if (links.link1.pPipe &&
            (links.link1.pPipe === hmi.constant.pipeCPosition.R || links.link1.pPipe === hmi.constant.pipeCPosition.L) &&
            (links.link2.pPipe === hmi.constant.pipeCPosition.R || links.link2.pPipe === hmi.constant.pipeCPosition.L)) {
            if (links.link1.yPipe >= links.link2.yPipe - pipeOffset && links.link2.yPipe >= links.link1.yPipe - pipeOffset) {
                return getPipeTracerHHorizontal(links);
            } else {
                return getPipeTracerHVertical(links);
            }
        } else {
            if (links.link1.pPipe &&
                (links.link1.pPipe === hmi.constant.pipeCPosition.T || links.link1.pPipe === hmi.constant.pipeCPosition.B) &&
                (links.link2.pPipe === hmi.constant.pipeCPosition.T || links.link2.pPipe === hmi.constant.pipeCPosition.B)) {
                if (links.link1.xPipe >= links.link2.xPipe - pipeOffset && links.link2.xPipe >= links.link1.xPipe - pipeOffset) {
                    return getPipeTracerVVertical(links);
                }
                else {
                    return getPipeTracerVHorizontal(links);
                }
            } else {
                if (links.link1.xPipe >= links.link2.xPipe - pipeOffset && links.link2.xPipe >= links.link1.xPipe - pipeOffset) {
                    return getPipeTracerMVertical(links);
                }
                else {
                    return getPipeTracerMHorizontal(links);
                }
            }
        }


    };

    // get the pipe model tracer horizontal horizontal
    var getPipeTracerHHorizontal = function (links) {
        if (links.link1.pPipe &&
            links.link1.pPipe === hmi.constant.pipeCPosition.R &&
            links.link2.pPipe &&
            links.link2.pPipe === hmi.constant.pipeCPosition.L) {
            if (links.link1.xPipe < links.link2.xPipe) {
                return hmi.constant.pipeTrace.RL_F_H;
            } else {
                return hmi.constant.pipeTrace.RL_I_H;
            }
        }
        if (links.link1.pPipe &&
            links.link1.pPipe === hmi.constant.pipeCPosition.L &&
            links.link2.pPipe &&
            links.link2.pPipe === hmi.constant.pipeCPosition.R) {
            if (links.link1.xPipe < links.link2.xPipe) {
                return hmi.constant.pipeTrace.LR_F_H;
            } else {
                return hmi.constant.pipeTrace.LR_I_H;
            }
        }

        if (links.link1.pPipe &&
            links.link1.pPipe === hmi.constant.pipeCPosition.R &&
            links.link2.pPipe &&
            links.link2.pPipe === hmi.constant.pipeCPosition.R) {
            if (links.link1.xPipe < links.link2.xPipe) {
                return hmi.constant.pipeTrace.RR_FT_H;
            } else {
                return hmi.constant.pipeTrace.RR_IT_H;
            }
        }

        if (links.link1.pPipe &&
            links.link1.pPipe === hmi.constant.pipeCPosition.L &&
            links.link2.pPipe &&
            links.link2.pPipe === hmi.constant.pipeCPosition.L) {
            if (links.link1.xPipe < links.link2.xPipe) {
                return hmi.constant.pipeTrace.LL_FT_H;
            } else {
                return hmi.constant.pipeTrace.LL_IT_H;
            }
        }
    };

    // get the pipe model tracer horizontal vertical
    var getPipeTracerHVertical = function (links) {

        if (links.link1.pPipe &&
            links.link1.pPipe === hmi.constant.pipeCPosition.R &&
            links.link2.pPipe &&
            links.link2.pPipe === hmi.constant.pipeCPosition.L) {
            if (links.link1.xPipe < links.link2.xPipe) {
                if (links.link1.yPipe < links.link2.yPipe) {
                    return hmi.constant.pipeTrace.RL_F_TB;
                } else {
                    return hmi.constant.pipeTrace.RL_F_BT;
                }
            } else {
                if (links.link1.yPipe < links.link2.yPipe) {
                    return hmi.constant.pipeTrace.RL_I_TB;
                } else {
                    return hmi.constant.pipeTrace.RL_I_BT;
                }
            }
        }
        if (links.link1.pPipe &&
            links.link1.pPipe === hmi.constant.pipeCPosition.L &&
            links.link2.pPipe &&
            links.link2.pPipe === hmi.constant.pipeCPosition.R) {
            if (links.link1.xPipe < links.link2.xPipe) {
                if (links.link1.yPipe < links.link2.yPipe) {
                    return hmi.constant.pipeTrace.LR_F_TB;
                } else {
                    return hmi.constant.pipeTrace.LR_F_BT;
                }
            } else {
                if (links.link1.yPipe < links.link2.yPipe) {
                    return hmi.constant.pipeTrace.LR_I_BT;
                } else {
                    return hmi.constant.pipeTrace.LR_I_TB;
                }
            }
        }
        if (links.link1.pPipe &&
            links.link1.pPipe === hmi.constant.pipeCPosition.R &&
            links.link2.pPipe &&
            links.link2.pPipe === hmi.constant.pipeCPosition.R) {
            if (links.link1.xPipe < links.link2.xPipe) {
                if (links.link1.yPipe < links.link2.yPipe) {
                    return hmi.constant.pipeTrace.RR_F_TBV;
                } else {
                    return hmi.constant.pipeTrace.RR_I_BTV;
                }
            } else {
                if (links.link1.yPipe < links.link2.yPipe) {
                    return hmi.constant.pipeTrace.RR_I_TBV;
                } else {
                    return hmi.constant.pipeTrace.RR_F_BTV;
                }
            }
        }

        if (links.link1.pPipe &&
            links.link1.pPipe === hmi.constant.pipeCPosition.L &&
            links.link2.pPipe &&
            links.link2.pPipe === hmi.constant.pipeCPosition.L) {
            if (links.link1.xPipe < links.link2.xPipe) {
                if (links.link1.yPipe < links.link2.yPipe) {
                    return hmi.constant.pipeTrace.LL_F_TBV;
                } else {
                    return hmi.constant.pipeTrace.LL_I_BTV;
                }
            } else {
                if (links.link1.yPipe < links.link2.yPipe) {
                    return hmi.constant.pipeTrace.LL_I_TBV;
                } else {
                    return hmi.constant.pipeTrace.LL_F_BTV;
                }
            }
        }
    };

    // get the pipe model tracer vertical horizontal
    var getPipeTracerVHorizontal = function (links) {
        if (links.link1.pPipe &&
            links.link1.pPipe === hmi.constant.pipeCPosition.T &&
            links.link2.pPipe &&
            links.link2.pPipe === hmi.constant.pipeCPosition.B) {
            if (links.link1.yPipe < links.link2.yPipe) {
                if (links.link1.xPipe < links.link2.xPipe) {
                    return hmi.constant.pipeTrace.TB_LR_D;
                } else {
                    return hmi.constant.pipeTrace.TB_RL_D;
                }
            } else {
                if (links.link1.xPipe < links.link2.xPipe) {
                    return hmi.constant.pipeTrace.TB_LR_U;
                } else {
                    return hmi.constant.pipeTrace.TB_RL_U;
                }
            }
        }
        if (links.link1.pPipe &&
            links.link1.pPipe === hmi.constant.pipeCPosition.B &&
            links.link2.pPipe &&
            links.link2.pPipe === hmi.constant.pipeCPosition.T) {
            if (links.link1.yPipe < links.link2.yPipe) {
                if (links.link1.xPipe < links.link2.xPipe) {
                    return hmi.constant.pipeTrace.BT_LR_D;
                } else {
                    return hmi.constant.pipeTrace.BT_RL_D;
                }
            } else {
                if (links.link1.xPipe < links.link2.xPipe) {
                    return hmi.constant.pipeTrace.BT_LR_U;
                } else {
                    return hmi.constant.pipeTrace.BT_RL_U;
                }
            }
        }
        if (links.link1.pPipe &&
            links.link1.pPipe === hmi.constant.pipeCPosition.T &&
            links.link2.pPipe &&
            links.link2.pPipe === hmi.constant.pipeCPosition.T) {
            if (links.link1.yPipe < links.link2.yPipe) {
                if (links.link1.xPipe < links.link2.xPipe) {
                    return hmi.constant.pipeTrace.TT_LR_D;
                } else {
                    return hmi.constant.pipeTrace.TT_RL_D;
                }
            } else {
                if (links.link1.xPipe < links.link2.xPipe) {
                    return hmi.constant.pipeTrace.TT_LR_U;
                } else {
                    return hmi.constant.pipeTrace.TT_RL_U;
                }
            }
        }

        if (links.link1.pPipe &&
            links.link1.pPipe === hmi.constant.pipeCPosition.B &&
            links.link2.pPipe &&
            links.link2.pPipe === hmi.constant.pipeCPosition.B) {
            if (links.link1.yPipe < links.link2.yPipe) {
                if (links.link1.xPipe < links.link2.xPipe) {
                    return hmi.constant.pipeTrace.BB_LR_D;
                } else {
                    return hmi.constant.pipeTrace.BB_RL_D;
                }
            } else {
                if (links.link1.xPipe < links.link2.xPipe) {
                    return hmi.constant.pipeTrace.BB_LR_U;
                } else {
                    return hmi.constant.pipeTrace.BB_RL_U;
                }
            }
        }
    };

    // get the pipe model tracer vertical vertical
    var getPipeTracerVVertical = function (links) {
        if (links.link1.pPipe &&
            links.link1.pPipe === hmi.constant.pipeCPosition.B &&
            links.link2.pPipe &&
            links.link2.pPipe === hmi.constant.pipeCPosition.T) {
            if (links.link1.yPipe < links.link2.yPipe) {
                return hmi.constant.pipeTrace.BT_V_D;
            } else {
                return hmi.constant.pipeTrace.BT_V_U;
            }
        }
        if (links.link1.pPipe &&
            links.link1.pPipe === hmi.constant.pipeCPosition.T &&
            links.link2.pPipe &&
            links.link2.pPipe === hmi.constant.pipeCPosition.B) {
            if (links.link1.yPipe < links.link2.yPipe) {
                return hmi.constant.pipeTrace.TB_V_D;
            } else {
                return hmi.constant.pipeTrace.TB_V_U;
            }
        }

        if (links.link1.pPipe &&
            links.link1.pPipe === hmi.constant.pipeCPosition.T &&
            links.link2.pPipe &&
            links.link2.pPipe === hmi.constant.pipeCPosition.T) {
            if (links.link1.yPipe < links.link2.yPipe) {
                return hmi.constant.pipeTrace.TT_V_D;
            } else {
                return hmi.constant.pipeTrace.TT_V_U;
            }
        }

        if (links.link1.pPipe &&
            links.link1.pPipe === hmi.constant.pipeCPosition.B &&
            links.link2.pPipe &&
            links.link2.pPipe === hmi.constant.pipeCPosition.B) {
            if (links.link1.yPipe < links.link2.yPipe) {
                return hmi.constant.pipeTrace.BB_V_D;
            } else {
                return hmi.constant.pipeTrace.BB_V_U;
            }
        }

    };

    // get the pipe model tracer mixed horizontal
    var getPipeTracerMHorizontal = function (links) {
        if (links.link1.pPipe &&
            links.link1.pPipe === hmi.constant.pipeCPosition.T &&
            links.link2.pPipe &&
            links.link2.pPipe === hmi.constant.pipeCPosition.R) {
            if (links.link1.yPipe < links.link2.yPipe) {
                if (links.link1.xPipe < links.link2.xPipe) {
                    return hmi.constant.pipeTrace.TR_LR_D;
                } else {
                    return hmi.constant.pipeTrace.TR_RL_D;
                }
            } else {
                if (links.link1.xPipe < links.link2.xPipe) {
                    return hmi.constant.pipeTrace.TR_LR_U;
                } else {
                    return hmi.constant.pipeTrace.TR_RL_U;
                }
            }
        }

        if (links.link1.pPipe &&
            links.link1.pPipe === hmi.constant.pipeCPosition.R &&
            links.link2.pPipe &&
            links.link2.pPipe === hmi.constant.pipeCPosition.T) {
            if (links.link1.yPipe < links.link2.yPipe) {
                if (links.link1.xPipe < links.link2.xPipe) {
                    return hmi.constant.pipeTrace.RT_LR_D;
                } else {
                    return hmi.constant.pipeTrace.RT_RL_D;
                }
            } else {
                if (links.link1.xPipe < links.link2.xPipe) {
                    return hmi.constant.pipeTrace.RT_LR_U;
                } else {
                    return hmi.constant.pipeTrace.RT_RL_U;
                }
            }
        }

        if (links.link1.pPipe &&
            links.link1.pPipe === hmi.constant.pipeCPosition.T &&
            links.link2.pPipe &&
            links.link2.pPipe === hmi.constant.pipeCPosition.L) {
            if (links.link1.yPipe < links.link2.yPipe) {
                if (links.link1.xPipe < links.link2.xPipe) {
                    return hmi.constant.pipeTrace.TL_LR_D;
                } else {
                    return hmi.constant.pipeTrace.TL_RL_D;
                }
            } else {
                if (links.link1.xPipe < links.link2.xPipe) {
                    return hmi.constant.pipeTrace.TL_LR_U;
                } else {
                    return hmi.constant.pipeTrace.TL_RL_U;
                }
            }
        }

        if (links.link1.pPipe &&
            links.link1.pPipe === hmi.constant.pipeCPosition.L &&
            links.link2.pPipe &&
            links.link2.pPipe === hmi.constant.pipeCPosition.T) {
            if (links.link1.yPipe < links.link2.yPipe) {
                if (links.link1.xPipe < links.link2.xPipe) {
                    return hmi.constant.pipeTrace.LT_LR_D;
                } else {
                    return hmi.constant.pipeTrace.LT_RL_D;
                }
            } else {
                if (links.link1.xPipe < links.link2.xPipe) {
                    return hmi.constant.pipeTrace.LT_LR_U;
                } else {
                    return hmi.constant.pipeTrace.LT_RL_U;
                }
            }
        }

        if (links.link1.pPipe &&
            links.link1.pPipe === hmi.constant.pipeCPosition.B &&
            links.link2.pPipe &&
            links.link2.pPipe === hmi.constant.pipeCPosition.R) {
            if (links.link1.yPipe < links.link2.yPipe) {
                if (links.link1.xPipe < links.link2.xPipe) {
                    return hmi.constant.pipeTrace.BR_LR_D;
                } else {
                    return hmi.constant.pipeTrace.BR_RL_D;
                }
            } else {
                if (links.link1.xPipe < links.link2.xPipe) {
                    return hmi.constant.pipeTrace.BR_LR_U;
                } else {
                    return hmi.constant.pipeTrace.BR_RL_U;
                }
            }
        }

        if (links.link1.pPipe &&
            links.link1.pPipe === hmi.constant.pipeCPosition.R &&
            links.link2.pPipe &&
            links.link2.pPipe === hmi.constant.pipeCPosition.B) {
            if (links.link1.yPipe < links.link2.yPipe) {
                if (links.link1.xPipe < links.link2.xPipe) {
                    return hmi.constant.pipeTrace.RB_LR_D;
                } else {
                    return hmi.constant.pipeTrace.RB_RL_D;
                }
            } else {
                if (links.link1.xPipe < links.link2.xPipe) {
                    return hmi.constant.pipeTrace.RB_LR_U;
                } else {
                    return hmi.constant.pipeTrace.RB_RL_U;
                }
            }
        }

        if (links.link1.pPipe &&
            links.link1.pPipe === hmi.constant.pipeCPosition.B &&
            links.link2.pPipe &&
            links.link2.pPipe === hmi.constant.pipeCPosition.L) {
            if (links.link1.yPipe < links.link2.yPipe) {
                if (links.link1.xPipe < links.link2.xPipe) {
                    return hmi.constant.pipeTrace.BL_LR_D;
                } else {
                    return hmi.constant.pipeTrace.BL_RL_D;
                }
            } else {
                if (links.link1.xPipe < links.link2.xPipe) {
                    return hmi.constant.pipeTrace.BL_LR_U;
                } else {
                    return hmi.constant.pipeTrace.BL_RL_U;
                }
            }
        }

        if (links.link1.pPipe &&
            links.link1.pPipe === hmi.constant.pipeCPosition.L &&
            links.link2.pPipe &&
            links.link2.pPipe === hmi.constant.pipeCPosition.B) {
            if (links.link1.yPipe < links.link2.yPipe) {
                if (links.link1.xPipe < links.link2.xPipe) {
                    return hmi.constant.pipeTrace.LB_LR_D;
                } else {
                    return hmi.constant.pipeTrace.LB_RL_D;
                }
            } else {
                if (links.link1.xPipe < links.link2.xPipe) {
                    return hmi.constant.pipeTrace.LB_LR_U;
                } else {
                    return hmi.constant.pipeTrace.LB_RL_U;
                }
            }
        }

    };

    // get the pipe model tracer mixed vertical
    var getPipeTracerMVertical = function (links) {
        if (links.link1.pPipe &&
            links.link1.pPipe === hmi.constant.pipeCPosition.B &&
            links.link2.pPipe &&
            links.link2.pPipe === hmi.constant.pipeCPosition.T) {
            if (links.link1.yPipe < links.link2.yPipe) {
                return hmi.constant.pipeTrace.BT_V_D;
            } else {
                return hmi.constant.pipeTrace.BT_V_U;
            }
        }
        if (links.link1.pPipe &&
            links.link1.pPipe === hmi.constant.pipeCPosition.T &&
            links.link2.pPipe &&
            links.link2.pPipe === hmi.constant.pipeCPosition.B) {
            if (links.link1.yPipe < links.link2.yPipe) {
                return hmi.constant.pipeTrace.TB_V_D;
            } else {
                return hmi.constant.pipeTrace.TB_V_U;
            }
        }

        if (links.link1.pPipe &&
            links.link1.pPipe === hmi.constant.pipeCPosition.T &&
            links.link2.pPipe &&
            links.link2.pPipe === hmi.constant.pipeCPosition.T) {
            if (links.link1.yPipe < links.link2.yPipe) {
                return hmi.constant.pipeTrace.TT_V_D;
            } else {
                return hmi.constant.pipeTrace.TT_V_U;
            }
        }

        if (links.link1.pPipe &&
            links.link1.pPipe === hmi.constant.pipeCPosition.B &&
            links.link2.pPipe &&
            links.link2.pPipe === hmi.constant.pipeCPosition.B) {
            if (links.link1.yPipe < links.link2.yPipe) {
                return hmi.constant.pipeTrace.BB_V_D;
            } else {
                return hmi.constant.pipeTrace.BB_V_U;
            }
        }

    };


    var pipeTracer = function (d, tracer, offset) {
        d.components = [];
        var oldOffset = [];
        if (d.pipeTracerMode === tracer) {
            oldOffset = JSON.parse(JSON.stringify(d.offsets));
            setPipeOffset(d, offset);
        } else {
            d.offsets = [];
            d.pipeTracerMode = tracer;
        }
        switch (tracer) {
            case hmi.constant.pipeTrace.RL_F_H:
                d = pipeTraceRLFH(d);
                break;
            case hmi.constant.pipeTrace.RL_I_H:
                d = pipeTraceRLIH(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.RL_I_TB:
                d = pipeTraceRLITB(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.RL_I_BT:
                d = pipeTraceRLIBT(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.RL_F_TB:
                d = pipeTraceRLFTB(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.RL_F_BT:
                d = pipeTraceRLFBT(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.LR_F_H:
                d = pipeTraceLRFH(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.LR_I_H:
                d = pipeTraceLRIH(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.LR_I_TB:
                d = pipeTraceLRITB(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.LR_I_BT:
                d = pipeTraceLRIBT(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.LR_F_TB:
                d = pipeTraceLRFTB(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.LR_F_BT:
                d = pipeTraceLRFBT(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.RR_FT_H:
                d = pipeTraceRRTFH(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.RR_IT_H:
                d = pipeTraceRRTIH(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.RR_F_TBV:
                d = pipeTraceRRFTB(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.RR_I_TBV:
                d = pipeTraceRRITB(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.RR_F_BTV:
                d = pipeTraceRRFBT(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.RR_I_BTV:
                d = pipeTraceRRIBT(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.LL_FT_H:
                d = pipeTraceLLTFH(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.LL_IT_H:
                d = pipeTraceLLTIH(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.LL_F_TBV:
                d = pipeTraceLLFTB(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.LL_I_TBV:
                d = pipeTraceLLITB(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.LL_F_BTV:
                d = pipeTraceLLFBT(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.LL_I_BTV:
                d = pipeTraceLLIBT(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.BT_V_D:
                d = pipeTrace_BT_V_D(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.BT_V_U:
                d = pipeTrace_BT_V_U(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.BT_LR_D:
                d = pipeTrace_BT_LR_D(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.BT_RL_D:
                d = pipeTrace_BT_RL_D(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.BT_LR_U:
                d = pipeTrace_BT_LR_U(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.BT_RL_U:
                d = pipeTrace_BT_RL_U(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.TB_V_D:
                d = pipeTrace_TB_V_D(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.TB_V_U:
                d = pipeTrace_TB_V_U(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.TB_LR_U:
                d = pipeTrace_TB_LR_U(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.TB_LR_D:
                d = pipeTrace_TB_LR_D(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.TB_RL_U:
                d = pipeTrace_TB_RL_U(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.TB_RL_D:
                d = pipeTrace_TB_RL_D(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.TT_LR_D:
                d = pipeTrace_TT_LR_D(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.TT_LR_U:
                d = pipeTrace_TT_LR_U(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.TT_RL_D:
                d = pipeTrace_TT_RL_D(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.TT_RL_U:
                d = pipeTrace_TT_RL_U(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.TT_V_D:
                d = pipeTrace_TT_V_D(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.TT_V_U:
                d = pipeTrace_TT_V_U(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.BB_LR_D:
                d = pipeTrace_BB_LR_D(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.BB_LR_U:
                d = pipeTrace_BB_LR_U(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.BB_RL_D:
                d = pipeTrace_BB_RL_D(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.BB_RL_U:
                d = pipeTrace_BB_RL_U(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.BB_V_D:
                d = pipeTrace_BB_V_D(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.BB_V_U:
                d = pipeTrace_BB_V_U(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.TR_LR_D:
                d = pipeTrace_TR_LR_D(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.TR_LR_U:
                d = pipeTrace_TR_LR_U(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.TR_RL_D:
                d = pipeTrace_TR_RL_D(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.TR_RL_U:
                d = pipeTrace_TR_RL_U(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.TR_V_D:
                d = pipeTrace_TT_V_D(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.TR_V_U:
                d = pipeTrace_TT_V_U(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.RT_LR_D:
                d = pipeTrace_RT_LR_D(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.RT_LR_U:
                d = pipeTrace_RT_LR_U(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.RT_RL_D:
                d = pipeTrace_RT_RL_D(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.RT_RL_U:
                d = pipeTrace_RT_RL_U(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.RT_V_D:
                d = pipeTrace_RT_V_D(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.RT_V_U:
                d = pipeTrace_RT_V_U(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.TL_LR_D:
                d = pipeTrace_TL_LR_D(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.TL_LR_U:
                d = pipeTrace_TL_LR_U(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.TL_RL_D:
                d = pipeTrace_TL_RL_D(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.TL_RL_U:
                d = pipeTrace_TL_RL_U(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.TL_V_D:
                d = pipeTrace_TT_V_D(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.TL_V_U:
                d = pipeTrace_TT_V_U(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.LT_LR_D:
                d = pipeTrace_LT_LR_D(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.LT_LR_U:
                d = pipeTrace_LT_LR_U(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.LT_RL_D:
                d = pipeTrace_LT_RL_D(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.LT_RL_U:
                d = pipeTrace_LT_RL_U(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.LT_V_D:
                d = pipeTrace_TT_V_D(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.LT_V_U:
                d = pipeTrace_TT_V_U(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.BR_LR_D:
                d = pipeTrace_BR_LR_D(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.BR_LR_U:
                d = pipeTrace_BR_LR_U(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.BR_RL_D:
                d = pipeTrace_BR_RL_D(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.BR_RL_U:
                d = pipeTrace_BR_RL_U(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.BR_V_D:
                d = pipeTrace_TT_V_D(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.BR_V_U:
                d = pipeTrace_TT_V_U(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.RB_LR_D:
                d = pipeTrace_RB_LR_D(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.RB_LR_U:
                d = pipeTrace_RB_LR_U(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.RB_RL_D:
                d = pipeTrace_RB_RL_D(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.RB_RL_U:
                d = pipeTrace_RB_RL_U(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.RB_V_D:
                d = pipeTrace_RB_V_D(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.RB_V_U:
                d = pipeTrace_RB_V_U(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.BL_LR_D:
                d = pipeTrace_BL_LR_D(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.BL_LR_U:
                d = pipeTrace_BL_LR_U(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.BL_RL_D:
                d = pipeTrace_BL_RL_D(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.BL_RL_U:
                d = pipeTrace_BL_RL_U(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.BL_V_D:
                d = pipeTrace_TT_V_D(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.BL_V_U:
                d = pipeTrace_TT_V_U(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.LB_LR_D:
                d = pipeTrace_LB_LR_D(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.LB_LR_U:
                d = pipeTrace_LB_LR_U(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.LB_RL_D:
                d = pipeTrace_LB_RL_D(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.LB_RL_U:
                d = pipeTrace_LB_RL_U(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.LB_V_D:
                d = pipeTrace_TT_V_D(d, oldOffset);
                break;
            case hmi.constant.pipeTrace.LB_V_U:
                d = pipeTrace_TT_V_U(d, oldOffset);
                break;
        }

        return d;
    };

    var setPipeOffset = function (d, offset) {
        if (offset) {
            var index = d.offsets.map(function (item) {
                return item.index;
            }).indexOf(offset.index);
            if (index !== -1) {
                if (d.offsets[index]) {
                    d.offsets[index] = offset;
                }
            } else {
                d.offsets.push(offset);
            }
        }
    };

    //   _            _
    // 1|_|----------|_|2
    //
    var pipeTraceRLFH = function (d) {
        pipeTraceH(d, d.links.link1.xPipe, d.links.link1.yPipe, d.links.link2.xPipe - d.links.link1.xPipe);
        return d;
    };

    //   _            _
    // 2|_|----------|_|1
    //
    var pipeTraceLRIH = function (d) {
        pipeTraceH(d, d.links.link2.xPipe, d.links.link2.yPipe, d.links.link1.xPipe - d.links.link2.xPipe);
        return d;
    };

    //   _____________
    //  |             |
    //  |   _     _   |
    //   --|_|2 1|_|--
    //
    var pipeTraceRLIH = function (d, oldOffset) {
        var minWith = componentWidth / 8;
        var width1 = minWith;
        var width2 = minWith;
        var ttOffset = null;
        for (var i = 0; i < d.offsets.length; i++) {
            var item = d.offsets[i];
            if (item && item.index === 6) {
                if (item.x < d.links.link1.xPipe + minWith) {
                    d.offsets[i] = oldOffset[i];
                    item = d.offsets[i];
                }

                width1 = item.x - d.links.link1.xPipe;
            }
            if (item && item.index === 2) {
                if (item.x > d.links.link2.xPipe - minWith || item.x < 0) {
                    d.offsets[i] = oldOffset[i];
                    item = d.offsets[i];
                }

                width2 = d.links.link2.xPipe - item.x;
            }
            if (item && item.index !== 6 && item.index !== 2) {
                if (item.y > d.links.link1.y - minWith || item.y < 0) {
                    d.offsets[i] = oldOffset[i];
                    item = oldOffset[i];
                }

                ttOffset = item;
            }
        }
        var width = d.links.link1.xPipe - d.links.link2.xPipe + width1 + width2 + getPipeUnionWidth(d) + getPipeUnionPosition(d);
        pipeTraceH(d, d.links.link2.xPipe - width2, d.links.link2.yPipe, width2);
        pipeUnionTR(d,
            d.links.link2.xPipe - width2 - getPipeUnionWidth(d),
            d.links.link2.yPipe - getPipeUnionPosition(d));
        if (ttOffset) {
            ttOffset.subIndex = ttOffset.index - d.components.length;
        }
        pipeUnionTraceHTT(d,
            d.links.link2.xPipe - width2 - getPipeUnionWidth(d),
            d.links.link2.yPipe - getPipeUnionPosition(d),
            width,
            1.5 * componentWidth,
            ttOffset);
        pipeUnionLT(d,
            d.links.link1.xPipe + width1,
            d.links.link1.yPipe - getPipeUnionPosition(d));
        pipeTraceH(d, d.links.link1.xPipe, d.links.link1.yPipe, width1);
        return d;
    };

    //   _____________
    //  |             |
    //  |   _     _   |
    //   --|_|1 2|_|--
    //
    var pipeTraceLRFH = function (d, oldOffset) {
        var minWith = componentWidth / 8;
        var width1 = minWith;
        var width2 = minWith;
        var ttOffset = null;
        for (var i = 0; i < d.offsets.length; i++) {
            var item = d.offsets[i];
            if (item && item.index === 6) {
                if (item.x < d.links.link2.xPipe + minWith) {
                    d.offsets[i] = oldOffset[i];
                    item = d.offsets[i];
                }

                width1 = item.x - d.links.link2.xPipe;
            }
            if (item && item.index === 2) {
                if (item.x > d.links.link1.xPipe - minWith || item.x < 0) {
                    d.offsets[i] = oldOffset[i];
                    item = d.offsets[i];
                }

                width2 = d.links.link1.xPipe - item.x;
            }
            if (item && item.index !== 6 && item.index !== 2) {
                if (item.y > d.links.link2.y - minWith || item.y < 0) {
                    d.offsets[i] = oldOffset[i];
                    item = oldOffset[i];
                }

                ttOffset = item;
            }
        }
        var width = d.links.link2.xPipe - d.links.link1.xPipe + width1 + width2 + getPipeUnionWidth(d) + getPipeUnionPosition(d);
        pipeTraceH(d, d.links.link1.xPipe - width2, d.links.link1.yPipe, width2);
        pipeUnionTR(d,
            d.links.link1.xPipe - width2 - getPipeUnionWidth(d),
            d.links.link1.yPipe - getPipeUnionPosition(d));
        if (ttOffset) {
            ttOffset.subIndex = ttOffset.index - d.components.length;
        }
        pipeUnionTraceHTT(d,
            d.links.link1.xPipe - width2 - getPipeUnionWidth(d),
            d.links.link1.yPipe - getPipeUnionPosition(d),
            width,
            1.5 * componentWidth,
            ttOffset);
        pipeUnionLT(d,
            d.links.link2.xPipe + width1,
            d.links.link2.yPipe - getPipeUnionPosition(d));
        pipeTraceH(d, d.links.link2.xPipe, d.links.link2.yPipe, width1);
        return d;
    };

    //        _______
    //       |       |
    //   _   |   _   |
    // 1|_|--  2|_|--
    //
    var pipeTraceRRTFH = function (d, oldOffset) {
        var minWith = componentWidth / 8;
        var width1 = minWith;
        var width2 = minWith;
        var ttOffset = null;
        for (var i = 0; i < d.offsets.length; i++) {
            var item = d.offsets[i];
            if (item && item.index === 6) {
                if (item.x < d.links.link2.xPipe + minWith) {
                    d.offsets[i] = oldOffset[i];
                    item = d.offsets[i];
                }

                width2 = item.x - d.links.link2.xPipe - getPipeUnionPosition(d);
            }
            if (item && item.index === 2) {
                if (item.x < d.links.link1.xPipe + minWith || item.x > d.links.link2.x - getPipeUnionWidth(d)) {
                    d.offsets[i] = oldOffset[i];
                    item = d.offsets[i];
                }

                width1 = item.x - d.links.link1.xPipe - getPipeUnionPosition(d);
            }
            if (item && item.index !== 6 && item.index !== 2) {
                if (item.y > d.links.link2.y - minWith || item.y < 0) {
                    d.offsets[i] = oldOffset[i];
                    item = oldOffset[i];
                }

                ttOffset = item;
            }
        }
        var width = d.links.link2.xPipe + width2 - (d.links.link1.xPipe + width1);
        pipeTraceH(d, d.links.link1.xPipe, d.links.link1.yPipe, width1);
        pipeUnionLT(d,
            d.links.link1.xPipe + width1,
            d.links.link1.yPipe - getPipeUnionPosition(d));
        if (ttOffset) {
            ttOffset.subIndex = ttOffset.index - d.components.length;
        }
        pipeUnionTraceHTT(d,
            d.links.link1.xPipe + width1 + getPipeUnionPosition(d),
            d.links.link1.yPipe - getPipeUnionPosition(d),
            width,
            1.5 * componentHeight,
            ttOffset);
        pipeUnionLT(d,
            d.links.link2.xPipe + width2,
            d.links.link2.yPipe - getPipeUnionPosition(d));
        pipeTraceH(d, d.links.link2.xPipe, d.links.link2.yPipe, width2);
        return d;
    };

    //        _______
    //       |       |
    //   _   |   _   |
    // 2|_|--  1|_|--
    //
    var pipeTraceRRTIH = function (d, oldOffset) {
        var minWith = componentWidth / 8;
        var width1 = minWith;
        var width2 = minWith;
        var ttOffset = null;
        for (var i = 0; i < d.offsets.length; i++) {
            var item = d.offsets[i];
            if (item && item.index === 6) {
                if (item.x < d.links.link1.xPipe + minWith) {
                    d.offsets[i] = oldOffset[i];
                    item = d.offsets[i];
                }

                width2 = item.x - d.links.link1.xPipe - getPipeUnionPosition(d);
            }
            if (item && item.index === 2) {
                if (item.x < d.links.link2.xPipe + minWith || item.x > d.links.link1.x - getPipeUnionWidth(d)) {
                    d.offsets[i] = oldOffset[i];
                    item = d.offsets[i];
                }

                width1 = item.x - d.links.link2.xPipe - getPipeUnionPosition(d);
            }
            if (item && item.index !== 6 && item.index !== 2) {
                if (item.y > d.links.link1.y - minWith || item.y < 0) {
                    d.offsets[i] = oldOffset[i];
                    item = oldOffset[i];
                }

                ttOffset = item;
            }
        }
        var width = d.links.link1.xPipe + width2 - (d.links.link2.xPipe + width1);
        pipeTraceH(d, d.links.link2.xPipe, d.links.link2.yPipe, width1);
        pipeUnionLT(d,
            d.links.link2.xPipe + width1,
            d.links.link2.yPipe - getPipeUnionPosition(d));
        if (ttOffset) {
            ttOffset.subIndex = ttOffset.index - d.components.length;
        }
        pipeUnionTraceHTT(d,
            d.links.link2.xPipe + width1 + getPipeUnionPosition(d),
            d.links.link2.yPipe - getPipeUnionPosition(d),
            width,
            1.5 * componentHeight,
            ttOffset);
        pipeUnionLT(d,
            d.links.link1.xPipe + width2,
            d.links.link1.yPipe - getPipeUnionPosition(d));
        pipeTraceH(d, d.links.link1.xPipe, d.links.link1.yPipe, width2);
        return d;
    };

    //   _
    // 1|_|------
    //           |
    //           |
    //       _   |
    //     2|_|--
    //
    var pipeTraceRRFTB = function (d, oldOffset) {
        var minWith = componentWidth / 8;
        var width = d.links.link2.xPipe + componentWidth / 8 - d.links.link1.xPipe;
        var width2 = minWith;
        if (d.offsets && d.offsets[0] && d.offsets[0].index === 2) {
            var item = d.offsets[0];
            if (item.x < d.links.link2.xPipe + minWith) {
                d.offsets[0] = oldOffset[0];
                item = d.offsets[0];
            }

            width = item.x - d.links.link1.xPipe - getPipeUnionPosition(d);
            width2 = item.x - d.links.link2.xPipe - getPipeUnionPosition(d);
        }
        pipeTraceH(d, d.links.link1.xPipe, d.links.link1.yPipe, width);
        pipeUnionTraceLL(d,
            d.links.link1.xPipe + width,
            d.links.link1.yPipe,
            d.links.link2.yPipe - d.links.link1.yPipe);
        pipeTraceH(d, d.links.link2.xPipe, d.links.link2.yPipe, width2);
        return d;
    };

    //   _
    // 2|_|------
    //           |
    //           |
    //       _   |
    //     1|_|--
    //
    var pipeTraceRRFBT = function (d, oldOffset) {
        var minWith = componentWidth / 8;
        var width = d.links.link1.xPipe + minWith - d.links.link2.xPipe;
        var width2 = minWith;
        if (d.offsets && d.offsets[0] && d.offsets[0].index === 2) {
            var item = d.offsets[0];
            if (item.x < d.links.link1.xPipe + minWith) {
                d.offsets[0] = oldOffset[0];
                item = d.offsets[0];
            }

            width = item.x - d.links.link2.xPipe - getPipeUnionPosition(d);
            width2 = item.x - d.links.link1.xPipe - getPipeUnionPosition(d);
        }
        pipeTraceH(d, d.links.link2.xPipe, d.links.link2.yPipe, width);
        pipeUnionTraceLL(d,
            d.links.link2.xPipe + width,
            d.links.link2.yPipe,
            d.links.link1.yPipe - d.links.link2.yPipe);
        pipeTraceH(d, d.links.link1.xPipe, d.links.link1.yPipe, width2);
        return d;
    };

    //       _
    //     1|_|--
    //           |
    //           |
    //   _       |
    // 2|_|------
    //
    var pipeTraceRRITB = function (d, oldOffset) {
        var minWith = componentWidth / 8;
        var width = d.links.link1.xPipe + minWith - d.links.link2.xPipe;
        var width2 = minWith;
        if (d.offsets && d.offsets[0] && d.offsets[0].index === 2) {
            var item = d.offsets[0];
            if (item.x < d.links.link1.xPipe + minWith) {
                d.offsets[0] = oldOffset[0];
                item = d.offsets[0];
            }

            width = item.x - d.links.link2.xPipe - getPipeUnionPosition(d);
            width2 = item.x - d.links.link1.xPipe - getPipeUnionPosition(d);
        }
        pipeTraceH(d, d.links.link1.xPipe, d.links.link1.yPipe, width2);
        pipeUnionTraceLL(d,
            d.links.link1.xPipe + width2,
            d.links.link1.yPipe,
            d.links.link2.yPipe - d.links.link1.yPipe);
        pipeTraceH(d, d.links.link2.xPipe, d.links.link2.yPipe, width);
        return d;
    };

    //       _
    //     2|_|--
    //           |
    //           |
    //   _       |
    // 1|_|------
    //
    var pipeTraceRRIBT = function (d, oldOffset) {
        var minWith = componentWidth / 8;
        var width = d.links.link2.xPipe + minWith - d.links.link1.xPipe;
        var width2 = minWith;
        if (d.offsets && d.offsets[0] && d.offsets[0].index === 2) {
            var item = d.offsets[0];
            if (item.x < d.links.link2.xPipe + minWith) {
                d.offsets[0] = oldOffset[0];
                item = d.offsets[0];
            }

            width = item.x - d.links.link1.xPipe - getPipeUnionPosition(d);
            width2 = item.x - d.links.link2.xPipe - getPipeUnionPosition(d);
        }
        pipeTraceH(d, d.links.link2.xPipe, d.links.link2.yPipe, width2);
        pipeUnionTraceLL(d,
            d.links.link2.xPipe + width2,
            d.links.link2.yPipe,
            d.links.link1.yPipe - d.links.link2.yPipe);
        pipeTraceH(d, d.links.link1.xPipe, d.links.link1.yPipe, width);
        return d;
    };

    //   ________
    //  |        |
    //  |   _    |   _
    //   --|_|1  -- |_|2
    //
    var pipeTraceLLTFH = function (d, oldOffset) {
        var minWith = componentWidth / 8;
        var width1 = minWith;
        var width2 = minWith;
        var ttOffset = null;
        for (var i = 0; i < d.offsets.length; i++) {
            var item = d.offsets[i];
            if (item && item.index === 6) {
                if (item.x < d.links.link1.xPipe + componentWidth + getPipeUnionWidth(d) + minWith || item.x > d.links.link2.xPipe + minWith) {
                    d.offsets[i] = oldOffset[i];
                    item = d.offsets[i];
                }

                width2 = d.links.link2.xPipe - item.x + getPipeUnionPosition(d);
            }
            if (item && item.index === 2) {
                if (item.x > d.links.link1.xPipe - minWith || item.x < minWith) {
                    d.offsets[i] = oldOffset[i];
                    item = d.offsets[i];
                }

                width1 = d.links.link1.xPipe - item.x + getPipeUnionPosition(d);
            }
            if (item && item.index !== 6 && item.index !== 2) {
                if (item.y > d.links.link2.y - minWith || item.y < 0) {
                    d.offsets[i] = oldOffset[i];
                    item = oldOffset[i];
                }

                ttOffset = item;
            }
        }
        var width = d.links.link2.xPipe - width2 - d.links.link1.xPipe + width1;
        pipeTraceH(d, d.links.link1.xPipe - width1, d.links.link1.yPipe, width1);
        pipeUnionTR(d,
            d.links.link1.xPipe - width1 - getPipeUnionWidth(d),
            d.links.link1.yPipe - getPipeUnionPosition(d));
        if (ttOffset) {
            ttOffset.subIndex = ttOffset.index - d.components.length;
        }
        pipeUnionTraceHTT(d,
            d.links.link1.xPipe - width1 - getPipeUnionWidth(d),
            d.links.link1.yPipe - getPipeUnionPosition(d),
            width,
            1.5 * componentHeight,
            ttOffset);
        pipeUnionTR(d,
            d.links.link2.xPipe - width2 - getPipeUnionWidth(d),
            d.links.link2.yPipe - getPipeUnionPosition(d));
        pipeTraceH(d, d.links.link2.xPipe - width2, d.links.link2.yPipe, width2);
        return d;
    };

    //   ________
    //  |        |
    //  |   _    |   _
    //   --|_|2  -- |_|1
    //
    var pipeTraceLLTIH = function (d, oldOffset) {
        var minWith = componentWidth / 8;
        var width1 = minWith;
        var width2 = minWith;
        var ttOffset = null;
        for (var i = 0; i < d.offsets.length; i++) {
            var item = d.offsets[i];
            if (item && item.index === 6) {
                if (item.x < d.links.link2.xPipe + componentWidth + getPipeUnionWidth(d) + minWith || item.x > d.links.link1.xPipe + minWith) {
                    d.offsets[i] = oldOffset[i];
                    item = d.offsets[i];
                }

                width2 = d.links.link1.xPipe - item.x + getPipeUnionPosition(d);
            }
            if (item && item.index === 2) {
                if (item.x > d.links.link2.xPipe - minWith || item.x < minWith) {
                    d.offsets[i] = oldOffset[i];
                    item = d.offsets[i];
                }

                width1 = d.links.link2.xPipe - item.x + getPipeUnionPosition(d);
            }
            if (item && item.index !== 6 && item.index !== 2) {
                if (item.y > d.links.link1.y - minWith || item.y < 0) {
                    d.offsets[i] = oldOffset[i];
                    item = oldOffset[i];
                }

                ttOffset = item;
            }
        }
        var width = d.links.link1.xPipe - width2 - d.links.link2.xPipe + width1;
        pipeTraceH(d, d.links.link2.xPipe - width1, d.links.link2.yPipe, width1);
        pipeUnionTR(d,
            d.links.link2.xPipe - width1 - getPipeUnionWidth(d),
            d.links.link2.yPipe - getPipeUnionPosition(d));
        if (ttOffset) {
            ttOffset.subIndex = ttOffset.index - d.components.length;
        }
        pipeUnionTraceHTT(d,
            d.links.link2.xPipe - width1 - getPipeUnionWidth(d),
            d.links.link2.yPipe - getPipeUnionPosition(d),
            width,
            1.5 * componentHeight,
            ttOffset);
        pipeUnionTR(d,
            d.links.link1.xPipe - width2 - getPipeUnionWidth(d),
            d.links.link1.yPipe - getPipeUnionPosition(d));
        pipeTraceH(d, d.links.link1.xPipe - width2, d.links.link1.yPipe, width2);
        return d;
    };

    //     _
    //  --|_|1
    // |
    // |
    // |           _
    //  ----------|_|2
    //
    var pipeTraceLLFTB = function (d, oldOffset) {
        var minWith = componentWidth / 8;
        var width2 = minWith;
        var width = d.links.link2.xPipe + minWith - d.links.link1.xPipe;
        if (d.offsets && d.offsets[0] && d.offsets[0].index === 2) {
            var item = d.offsets[0];
            if (item.x > d.links.link1.xPipe - minWith) {
                d.offsets[0] = oldOffset[0];
                item = d.offsets[0];
            }

            width = d.links.link2.xPipe - item.x;
            width2 = d.links.link1.xPipe - item.x;
        }
        pipeTraceH(d, d.links.link1.xPipe - width2, d.links.link1.yPipe, width2);
        pipeUnionTraceRR(d,
            d.links.link1.xPipe - width2,
            d.links.link1.yPipe,
            d.links.link2.yPipe - d.links.link1.yPipe);
        pipeTraceH(d, d.links.link2.xPipe - width, d.links.link2.yPipe, width);
        return d;
    };

    //     _
    //  --|_|2
    // |
    // |
    // |           _
    //  ----------|_|1
    //
    var pipeTraceLLFBT = function (d, oldOffset) {
        var minWith = componentWidth / 8;
        var width2 = minWith;
        var width = d.links.link1.xPipe + minWith - d.links.link2.xPipe;
        if (d.offsets && d.offsets[0] && d.offsets[0].index === 2) {
            var item = d.offsets[0];
            if (item.x > d.links.link2.xPipe - getPipeUnionPosition(d) - minWith) {
                d.offsets[0] = oldOffset[0];
                item = d.offsets[0];
            }

            width = d.links.link1.xPipe - item.x;
            width2 = d.links.link2.xPipe - item.x;
        }
        pipeTraceH(d, d.links.link2.xPipe - width2, d.links.link2.yPipe, width2);
        pipeUnionTraceRR(d,
            d.links.link2.xPipe - width2,
            d.links.link2.yPipe,
            d.links.link1.yPipe - d.links.link2.yPipe);
        pipeTraceH(d, d.links.link1.xPipe - width, d.links.link1.yPipe, width);
        return d;
    };

    //              _
    //  -----------|_|1
    // |
    // |
    // |    _
    //  ---|_|2
    //
    var pipeTraceLLITB = function (d, oldOffset) {
        var minWith = componentWidth / 8;
        var width2 = minWith;
        var width = d.links.link1.xPipe + minWith - d.links.link2.xPipe;
        if (d.offsets && d.offsets[0] && d.offsets[0].index === 2) {
            var item = d.offsets[0];
            if (item.x > d.links.link2.xPipe - minWith) {
                d.offsets[0] = oldOffset[0];
                item = d.offsets[0];
            }

            width = d.links.link1.xPipe - item.x;
            width2 = d.links.link2.xPipe - item.x;
        }
        pipeTraceH(d, d.links.link1.xPipe - width, d.links.link1.yPipe, width);
        pipeUnionTraceRR(d,
            d.links.link1.xPipe - width,
            d.links.link1.yPipe,
            d.links.link2.yPipe - d.links.link1.yPipe);
        pipeTraceH(d, d.links.link2.xPipe - width2, d.links.link2.yPipe, width2);
        return d;
    };

    //              _
    //  -----------|_|2
    // |
    // |
    // |    _
    //  ---|_|1
    //
    var pipeTraceLLIBT = function (d, oldOffset) {
        var minWith = componentWidth / 8;
        var width2 = minWith;
        var width = d.links.link2.xPipe + minWith - d.links.link1.xPipe;
        if (d.offsets && d.offsets[0] && d.offsets[0].index === 2) {
            var item = d.offsets[0];
            if (item.x > d.links.link1.xPipe - minWith) {
                d.offsets[0] = oldOffset[0];
                item = d.offsets[0];
            }

            width = d.links.link2.xPipe - item.x;
            width2 = d.links.link1.xPipe - item.x;
        }
        pipeTraceH(d, d.links.link2.xPipe - width, d.links.link2.yPipe, width);
        pipeUnionTraceRR(d,
            d.links.link2.xPipe - width,
            d.links.link2.yPipe,
            d.links.link1.yPipe - d.links.link2.yPipe);
        pipeTraceH(d, d.links.link1.xPipe - width2, d.links.link1.yPipe, width2);
        return d;
    };

    //   _
    // 1|_|------
    //           |
    //           |
    //           |        _
    //            -------|_|2
    //
    var pipeTraceRLFTB = function (d, oldOffset) {
        var minWith = componentWidth / 8;
        var width = d.links.link2.xPipe - d.links.link1.xPipe - getDefaultWidth(d) - (2 * getPipeUnionPosition(d));
        var width1 = width / 2;
        var width2 = width / 2;
        if (d.offsets && d.offsets[0] && d.offsets[0].index === 2) {
            var item = d.offsets[0];
            if (item.x < d.links.link1.xPipe + minWith || item.x > d.links.link2.xPipe - getDefaultWidth(d) - minWith) {
                d.offsets[0] = oldOffset[0];
                item = d.offsets[0];
            }

            width1 = item.x - d.links.link1.xPipe - getPipeUnionPosition(d);
            width2 = width - width1;
        }
        pipeTraceH(d, d.links.link1.xPipe, d.links.link1.yPipe, width1);
        pipeUnionTraceRLTB(d, d.links.link1.xPipe + width1, d.links.link1.yPipe, d.links.link2.yPipe - d.links.link1.yPipe);
        pipeTraceH(d, d.links.link2.xPipe - width2, d.links.link2.yPipe, width2);
        return d;
    };

    //   _
    // 2|_|------
    //           |
    //           |
    //           |        _
    //            -------|_|1
    //
    var pipeTraceLRITB = function (d, oldOffset) {
        var minWith = componentWidth / 8;
        var width = d.links.link1.xPipe - d.links.link2.xPipe - getDefaultWidth(d) - (2 * getPipeUnionPosition(d));
        var width1 = width / 2;
        var width2 = width / 2;
        if (d.offsets && d.offsets[0] && d.offsets[0].index === 2) {
            var item = d.offsets[0];
            if (item.x < d.links.link2.xPipe + minWith || item.x > d.links.link1.xPipe - getDefaultWidth(d) - minWith) {
                d.offsets[0] = oldOffset[0];
                item = d.offsets[0];
            }

            width1 = item.x - d.links.link2.xPipe - getPipeUnionPosition(d);
            width2 = width - width1;
        }
        pipeTraceH(d, d.links.link2.xPipe, d.links.link2.yPipe, width1);
        pipeUnionTraceRLTB(d, d.links.link2.xPipe + width1, d.links.link2.yPipe, d.links.link1.yPipe - d.links.link2.yPipe);
        pipeTraceH(d, d.links.link1.xPipe - width2, d.links.link1.yPipe, width2);
        return d;
    };

    //                    _
    //            -------|_|2
    //           |
    //           |
    //   _       |
    // 1|_|------
    //
    var pipeTraceRLFBT = function (d, oldOffset) {
        var minWith = componentWidth / 8;
        var width = d.links.link2.xPipe - d.links.link1.xPipe - getDefaultWidth(d) - (2 * getPipeUnionPosition(d));
        var width1 = width / 2;
        var width2 = width / 2;
        if (d.offsets && d.offsets[0] && d.offsets[0].index === 2) {
            var item = d.offsets[0];
            if (item.x < d.links.link1.xPipe + minWith || item.x > d.links.link2.xPipe - getDefaultWidth(d) - minWith) {
                d.offsets[0] = oldOffset[0];
                item = d.offsets[0];
            }

            width1 = item.x - d.links.link1.xPipe - getPipeUnionPosition(d);
            width2 = width - width1;
        }
        pipeTraceH(d, d.links.link1.xPipe, d.links.link1.yPipe, width1);
        pipeUnionTraceRLBT(d, d.links.link1.xPipe + width1, d.links.link1.yPipe, d.links.link1.yPipe - d.links.link2.yPipe);
        pipeTraceH(d, d.links.link2.xPipe - width2, d.links.link2.yPipe, width2);
        return d;
    };

    //                    _
    //            -------|_|1
    //           |
    //           |
    //   _       |
    // 2|_|------
    //
    var pipeTraceLRIBT = function (d, oldOffset) {
        var minWith = componentWidth / 8;
        var width = d.links.link1.xPipe - d.links.link2.xPipe - getDefaultWidth(d) - (2 * getPipeUnionPosition(d));
        var width1 = width / 2;
        var width2 = width / 2;
        if (d.offsets && d.offsets[0] && d.offsets[0].index === 2) {
            var item = d.offsets[0];
            if (item.x < d.links.link2.xPipe + minWith || item.x > d.links.link1.xPipe - getDefaultWidth(d) - minWith) {
                d.offsets[0] = oldOffset[0];
                item = d.offsets[0];
            }

            width1 = item.x - d.links.link2.xPipe - getPipeUnionPosition(d);
            width2 = width - width1;
        }
        pipeTraceH(d, d.links.link2.xPipe, d.links.link2.yPipe, width1);
        pipeUnionTraceRLBT(d, d.links.link2.xPipe + width1, d.links.link2.yPipe, d.links.link2.yPipe - d.links.link1.yPipe);
        pipeTraceH(d, d.links.link1.xPipe - width2, d.links.link1.yPipe, width2);
        return d;
    };

    //       _
    //     1|_|--
    //           |
    //   ________|
    //  |
    //  |   _
    //   --|_|2
    //
    var pipeTraceRLITB = function (d, oldOffset) {
        var minWith = componentWidth / 8;
        var width1 = minWith;
        var width2 = minWith;
        var ttOffset = null;
        for (var i = 0; i < d.offsets.length; i++) {
            var item = d.offsets[i];
            if (item && item.index === 6) {
                if (item.x > d.links.link2.xPipe - getDefaultWidth(d) - minWith || item.x < minWith) {
                    d.offsets[i] = oldOffset[i];
                    item = d.offsets[i];
                }

                width2 = d.links.link2.xPipe - item.x - getPipeUnionWidth(d);
            }
            if (item && item.index === 2) {
                if (item.x < d.links.link1.xPipe + minWith) {
                    d.offsets[i] = oldOffset[i];
                    item = d.offsets[i];
                }

                width1 = item.x - d.links.link1.xPipe - getPipeUnionPosition(d);
            }
            if (item && item.index !== 6 && item.index !== 2) {
                if (item.y > d.links.link2.y || item.y < d.links.link1.y + componentHeight + (2 * getPipeUnionPosition(d))) {
                    d.offsets[i] = oldOffset[i];
                    item = oldOffset[i];
                }

                ttOffset = item;
            }
        }
        var width = d.links.link1.xPipe - d.links.link2.xPipe + width1 + width2;
        pipeTraceH(d, d.links.link1.xPipe, d.links.link1.yPipe, width1);
        if (ttOffset) {
            ttOffset.subIndex = ttOffset.index - d.components.length;
        }
        pipeUnionTraceTB(d, d.links.link1.xPipe + width1, d.links.link1.yPipe,
            width, d.links.link2.yPipe - d.links.link1.yPipe, ttOffset);
        pipeTraceH(d, d.links.link2.xPipe - width2, d.links.link2.yPipe, width2);
        return d;
    };

    //       _
    //     2|_|--
    //           |
    //   ________|
    //  |
    //  |   _
    //   --|_|1
    //
    var pipeTraceLRFBT = function (d, oldOffset) {
        var minWith = componentWidth / 8;
        var width1 = minWith;
        var width2 = minWith;
        var ttOffset = null;
        for (var i = 0; i < d.offsets.length; i++) {
            var item = d.offsets[i];
            if (item && item.index === 6) {
                if (item.x > d.links.link1.xPipe - getDefaultWidth(d) - minWith || item.x < minWith) {
                    d.offsets[i] = oldOffset[i];
                    item = d.offsets[i];
                }

                width2 = d.links.link1.xPipe - item.x - getPipeUnionWidth(d);
            }
            if (item && item.index === 2) {
                if (item.x < d.links.link2.xPipe + minWith) {
                    d.offsets[i] = oldOffset[i];
                    item = d.offsets[i];
                }

                width1 = item.x - d.links.link2.xPipe - getPipeUnionPosition(d);
            }
            if (item && item.index !== 6 && item.index !== 2) {
                if (item.y > d.links.link1.y || item.y < d.links.link2.y + componentHeight + (2 * getPipeUnionPosition(d))) {
                    d.offsets[i] = oldOffset[i];
                    item = oldOffset[i];
                }

                ttOffset = item;
            }
        }
        var width = d.links.link2.xPipe - d.links.link1.xPipe + width1 + width2;
        pipeTraceH(d, d.links.link2.xPipe, d.links.link2.yPipe, width1);
        if (ttOffset) {
            ttOffset.subIndex = ttOffset.index - d.components.length;
        }
        pipeUnionTraceTB(d, d.links.link2.xPipe + width1, d.links.link2.yPipe,
            width, d.links.link1.yPipe - d.links.link2.yPipe, ttOffset);
        pipeTraceH(d, d.links.link1.xPipe - width2, d.links.link1.yPipe, width2);
        return d;
    };

    //       _
    //    --|_|2
    //   |
    //   |________
    //            |
    //        _   |
    //      1|_|--
    //
    var pipeTraceRLIBT = function (d, oldOffset) {
        var w1 = componentWidth / 2;
        var x1 = d.links.link2.xPipe - w1;
        var y1 = d.links.link2.yPipe + getPipeUnionHeight(d);
        var w2 = w1;
        var x2 = d.links.link1.xPipe;
        var y2 = d.links.link1.yPipe - getPipeUnionPosition(d);

        var y3 = y1;

        var h3 = y2 - y1;
        var outLimit1 = function (offset) {
            return offset.x < 0 || offset.x > d.links.link2.xPipe - w1;
        };
        var offset1 = getOffset(d, 2, outLimit1, oldOffset);
        if (offset1) {
            x1 = offset1.x;
            w1 = d.links.link2.xPipe - offset1.x;
        }
        var outLimit2 = function (offset) {
            return offset.x < d.links.link1.xPipe + getPipeUnionPosition(d);
        };
        var offset2 = getOffset(d, 6, outLimit2, oldOffset);
        if (offset2) {
            w2 = offset2.x - d.links.link1.xPipe;
        }

        var x3 = x1;
        var w3 = d.links.link1.xPipe + w2 - d.links.link2.xPipe + w1;
        var outLimit3 = function (offset) {
            return offset.y < d.links.link2.yPipe + getPipeUnionHeight(d) + getPipeUnionPosition(d) || offset.y > d.links.link1.y - getPipeUnionHeight(d);
        };
        var offset3 = getOffset(d, 4, outLimit3, oldOffset);
        traceAux_BR_H(d, x1, y1, w1);
        traceAux_V_TR_H_LB_V(d, x3, y3, w3, h3, offset3);
        traceAux_H_LT(d, x2, y2, w2);
        return d;
    };

    //       _
    //    --|_|1
    //   |
    //   |________
    //            |
    //        _   |
    //      2|_|--
    //
    var pipeTraceLRFTB = function (d, oldOffset) {
        var w1 = componentWidth / 2;
        var x1 = d.links.link1.xPipe - w1;
        var y1 = d.links.link1.yPipe + getPipeUnionHeight(d);
        var w2 = w1;
        var x2 = d.links.link2.xPipe;
        var y2 = d.links.link2.yPipe - getPipeUnionPosition(d);

        var y3 = y1;

        var h3 = y2 - y1;
        var outLimit1 = function (offset) {
            return offset.x < 0 || offset.x > d.links.link1.xPipe - w1;
        };
        var offset1 = getOffset(d, 2, outLimit1, oldOffset);
        if (offset1) {
            x1 = offset1.x;
            w1 = d.links.link1.xPipe - offset1.x;
        }
        var outLimit2 = function (offset) {
            return offset.x < d.links.link2.xPipe + getPipeUnionPosition(d);
        };
        var offset2 = getOffset(d, 6, outLimit2, oldOffset);
        if (offset2) {
            w2 = offset2.x - d.links.link2.xPipe;
        }

        var x3 = x1;
        var w3 = d.links.link2.xPipe + w2 - d.links.link1.xPipe + w1;
        var outLimit3 = function (offset) {
            return offset.y < d.links.link1.yPipe + getPipeUnionHeight(d) + getPipeUnionPosition(d) || offset.y > d.links.link2.y - getPipeUnionHeight(d);
        };
        var offset3 = getOffset(d, 4, outLimit3, oldOffset);
        traceAux_BR_H(d, x1, y1, w1);
        traceAux_V_TR_H_LB_V(d, x3, y3, w3, h3, offset3);
        traceAux_H_LT(d, x2, y2, w2);
        return d;
    };

    //   _
    // 1|_|
    //   |
    //   |
    //   |
    //   -
    // 2|_|
    //
    var pipeTrace_BT_V_D = function (d) {
        pipeTraceV(d, d.links.link1.xPipe, d.links.link1.yPipe, d.links.link2.yPipe - d.links.link1.yPipe);
        return d;
    };

    //   _
    // 2|_|
    //   |
    //   |
    //   |
    //   -
    // 1|_|
    //
    var pipeTrace_TB_V_U = function (d) {
        pipeTraceV(d, d.links.link2.xPipe, d.links.link2.yPipe, d.links.link1.yPipe - d.links.link2.yPipe);
        return d;
    };

    //    ___
    //   |   |
    //   -   |
    // 1|_|  |
    //       |
    //   -   |
    // 2|_|  |
    //   |___|
    //
    var pipeTrace_TB_V_D = function (d, oldOffset) {
        var height = d.links.link2.yPipe - d.links.link1.yPipe;
        var width = componentWidth;
        var y1 = d.links.link1.yPipe - getPipeUnionHeight(d);
        var h1 = getPipeUnionHeight(d);
        var y2 = d.links.link2.yPipe;
        var h2 = getPipeUnionHeight(d);
        var x3 = d.links.link1.xPipe + width;

        var outLimit1 = function (offset) {
            return offset.y + getPipeUnionHeight(d) > d.links.link1.yPipe || offset.y < 0;
        };
        var offset = getOffset(d, 2, outLimit1, oldOffset);
        if (offset) {
            y1 = offset.y;
            h1 = d.links.link1.yPipe - y1;
        }
        var outLimit2 = function (offset) {
            return offset.x < d.links.link1.x + componentWidth;
        };
        offset = getOffset(d, 4, outLimit2, oldOffset);
        if (offset) {
            width = offset.x - d.links.link1.xPipe - getPipeUnionPosition(d);
            x3 = offset.x - getPipeUnionPosition(d);
        }
        var outLimit3 = function (offset) {
            return offset.y < d.links.link2.yPipe + getPipeUnionHeight(d);
        };
        offset = getOffset(d, 8, outLimit3, oldOffset);
        if (offset) {
            h2 = offset.y - y2;
        }

        var h3 = height + h1 + h2;
        traceAux_BR_V_H(d, d.links.link1.xPipe, y1, width, h1);
        traceAux_LB_V_LT(d, x3, y1, h3);
        traceAux_V_TR_H(d, d.links.link2.xPipe, y2, width, h2);
        return d;
    };

    //    ___
    //   |   |
    //   -   |
    // 2|_|  |
    //       |
    //   -   |
    // 1|_|  |
    //   |___|
    //
    var pipeTrace_BT_V_U = function (d, oldOffset) {
        var height = d.links.link1.yPipe - d.links.link2.yPipe;
        var width = componentWidth;
        var y1 = d.links.link2.yPipe - getPipeUnionHeight(d);
        var h1 = getPipeUnionHeight(d);
        var y2 = d.links.link1.yPipe;
        var h2 = getPipeUnionHeight(d);
        var x3 = d.links.link2.xPipe + width;

        var outLimit1 = function (offset) {
            return offset.y + getPipeUnionHeight(d) > d.links.link2.yPipe || offset.y < 0;
        };
        var offset = getOffset(d, 2, outLimit1, oldOffset);
        if (offset) {
            y1 = offset.y;
            h1 = d.links.link2.yPipe - y1;
        }
        var outLimit2 = function (offset) {
            return offset.x < d.links.link1.x + componentWidth;
        };
        offset = getOffset(d, 4, outLimit2, oldOffset);
        if (offset) {
            width = offset.x - d.links.link2.xPipe - getPipeUnionPosition(d);
            x3 = offset.x - getPipeUnionPosition(d);
        }
        var outLimit3 = function (offset) {
            return offset.y < d.links.link1.yPipe + getPipeUnionHeight(d);
        };
        offset = getOffset(d, 8, outLimit3, oldOffset);
        if (offset) {
            h2 = offset.y - y2;
        }

        var h3 = height + h1 + h2;
        traceAux_BR_V_H(d, d.links.link2.xPipe, y1, width, h1);
        traceAux_LB_V_LT(d, x3, y1, h3);
        traceAux_V_TR_H(d, d.links.link1.xPipe, y2, width, h2);
        return d;
    };



    //    _______
    //   |       |
    //   -       |
    // 1|_|      |
    //           |
    //           |        _
    //           |       |_|2
    //           |________|
    //
    //
    var pipeTrace_TB_LR_D = function (d, oldOffset) {
        var width = d.links.link2.xPipe - d.links.link1.xPipe;
        var height = d.links.link2.yPipe - d.links.link1.yPipe;
        var x1 = d.links.link1.xPipe;
        var y1 = d.links.link1.yPipe - getPipeUnionHeight(d);
        var h1 = getPipeUnionHeight(d);
        var outLimit1 = function (offset) {
            return offset.y + getPipeUnionHeight(d) > d.links.link1.yPipe || offset.y < 0;
        };
        var offset = getOffset(d, 2, outLimit1, oldOffset);
        if (offset) {
            y1 = offset.y;
            h1 = d.links.link1.yPipe - y1;
        }
        var h3 = getPipeUnionHeight(d);
        var outLimit2 = function (offset) {
            return offset.y - getPipeUnionHeight(d) < d.links.link2.yPipe;
        };
        offset = getOffset(d, 6, outLimit2, oldOffset);
        if (offset) {
            h3 = offset.y - d.links.link2.yPipe;
        }

        var x2 = x1 + getPipeUnionWidth(d);
        var y2 = y1;
        var h2 = height + h1 + h3;
        var w2 = width - getPipeUnionWidth(d) - getPipeUnionPosition(d);
        var outLimit3 = function (offset) {
            return offset.x < d.links.link1.x + componentWidth ||
                offset.x > d.links.link2.x - getPipeUnionWidth(d);
        };
        offset = getOffset(d, 4, outLimit3, oldOffset);

        traceAux_BR_V(d, x1, y1, h1);
        traceAux_H_LB_V_TR_H(d, x2, y2, w2, h2, offset);
        traceAux_V_LT(d, d.links.link2.xPipe, d.links.link2.yPipe, h3);
        return d;
    };

    //    _______
    //   |       |
    //   -       |
    // 2|_|      |
    //           |
    //           |        _
    //           |       |_|1
    //           |________|
    //
    //
    var pipeTrace_BT_RL_U = function (d, oldOffset) {
        var width = d.links.link1.xPipe - d.links.link2.xPipe;
        var height = d.links.link1.yPipe - d.links.link2.yPipe;
        var x1 = d.links.link2.xPipe;
        var y1 = d.links.link2.yPipe - getPipeUnionHeight(d);
        var h1 = getPipeUnionHeight(d);
        var outLimit1 = function (offset) {
            return offset.y + getPipeUnionHeight(d) > d.links.link2.yPipe || offset.y < 0;
        };
        var offset = getOffset(d, 2, outLimit1, oldOffset);
        if (offset) {
            y1 = offset.y;
            h1 = d.links.link2.yPipe - y1;
        }
        var h3 = getPipeUnionHeight(d);
        var outLimit2 = function (offset) {
            return offset.y - getPipeUnionHeight(d) < d.links.link1.yPipe;
        };
        offset = getOffset(d, 6, outLimit2, oldOffset);
        if (offset) {
            h3 = offset.y - d.links.link1.yPipe;
        }

        var x2 = x1 + getPipeUnionWidth(d);
        var y2 = y1;
        var h2 = height + h1 + h3;
        var w2 = width - getPipeUnionWidth(d) - getPipeUnionPosition(d);
        var outLimit3 = function (offset) {
            return offset.x < d.links.link2.x + componentWidth ||
                offset.x > d.links.link1.x - getPipeUnionWidth(d);
        };
        offset = getOffset(d, 4, outLimit3, oldOffset);

        traceAux_BR_V(d, x1, y1, h1);
        traceAux_H_LB_V_TR_H(d, x2, y2, w2, h2, offset);
        traceAux_V_LT(d, d.links.link1.xPipe, d.links.link1.yPipe, h3);
        return d;
    };


    //             _______
    //            |       |
    //            |       -
    //            |     1|_|
    //            |
    //   _        |
    //  |_|2      |
    //   |________|
    //
    //
    var pipeTrace_TB_RL_D = function (d, oldOffset) {
        var width = d.links.link1.xPipe - d.links.link2.xPipe;
        var height = d.links.link2.yPipe - d.links.link1.yPipe;
        var x1 = d.links.link2.xPipe;
        var y1 = d.links.link2.yPipe;
        var h1 = getPipeUnionHeight(d);
        var x2 = x1 + getPipeUnionWidth(d);
        var h3 = getPipeUnionHeight(d);
        var x3 = d.links.link1.xPipe - getPipeUnionPosition(d);
        var y3 = d.links.link1.yPipe - getPipeUnionHeight(d);
        var outLimit1 = function (offset) {
            return offset.y < d.links.link2.yPipe + getPipeUnionHeight(d) || offset.y < 0;
        };
        var offset = getOffset(d, 2, outLimit1, oldOffset);
        if (offset) {
            h1 = offset.y - d.links.link2.yPipe;
        }

        var outLimit2 = function (offset) {
            return offset.y > d.links.link1.yPipe - getPipeUnionHeight(d);
        };
        offset = getOffset(d, 6, outLimit2, oldOffset);
        if (offset) {
            y3 = offset.y;
            h3 = d.links.link1.yPipe - offset.y;
        }

        var y2 = y1 + h1 - getDefaultHeight(d);
        var h2 = height + h1 + h3;
        var w2 = width - getPipeUnionPosition(d);
        var outLimit3 = function (offset) {
            return offset.x < d.links.link2.x + componentWidth ||
                offset.x > d.links.link1.x - getPipeUnionWidth(d);
        };
        offset = getOffset(d, 3, outLimit3, oldOffset);

        traceAux_V_TR(d, x1, y1, h1);
        traceAux_H_LT_V_TR_H(d, x2, y2, w2, h2, offset);
        traceAux_LB_V(d, x3, y3, h3);
        return d;
    };

    //             _______
    //            |       |
    //            |       -
    //            |     2|_|
    //            |
    //   _        |
    //  |_|1      |
    //   |________|
    //
    //
    var pipeTrace_BT_LR_U = function (d, oldOffset) {
        var width = d.links.link2.xPipe - d.links.link1.xPipe;
        var height = d.links.link1.yPipe - d.links.link2.yPipe;
        var x1 = d.links.link1.xPipe;
        var y1 = d.links.link1.yPipe;
        var h1 = getPipeUnionHeight(d);
        var x2 = x1 + getPipeUnionWidth(d);
        var h3 = getPipeUnionHeight(d);
        var x3 = d.links.link2.xPipe - getPipeUnionPosition(d);
        var y3 = d.links.link2.yPipe - getPipeUnionHeight(d);
        var outLimit1 = function (offset) {
            return offset.y < d.links.link1.yPipe + getPipeUnionHeight(d) || offset.y < 0;
        };
        var offset = getOffset(d, 2, outLimit1, oldOffset);
        if (offset) {
            h1 = offset.y - d.links.link1.yPipe;
        }

        var outLimit2 = function (offset) {
            return offset.y > d.links.link2.yPipe - getPipeUnionHeight(d);
        };
        offset = getOffset(d, 6, outLimit2, oldOffset);
        if (offset) {
            y3 = offset.y;
            h3 = d.links.link2.yPipe - offset.y;
        }

        var y2 = y1 + h1 - getDefaultHeight(d);
        var h2 = height + h1 + h3;
        var w2 = width - getPipeUnionPosition(d);
        var outLimit3 = function (offset) {
            return offset.x < d.links.link1.x + componentWidth ||
                offset.x > d.links.link2.x - getPipeUnionWidth(d);
        };
        offset = getOffset(d, 3, outLimit3, oldOffset);

        traceAux_V_TR(d, x1, y1, h1);
        traceAux_H_LT_V_TR_H(d, x2, y2, w2, h2, offset);
        traceAux_LB_V(d, x3, y3, h3);
        return d;
    };

    //           _
    //         2|_|
    //           |
    //    _______|
    //   |
    //   |
    //   -
    // 1|_|
    //
    var pipeTrace_TB_LR_U = function (d, oldOffset) {
        var width = d.links.link2.xPipe - d.links.link1.xPipe;
        var height = d.links.link1.yPipe - d.links.link2.yPipe;
        var outLimit = function (offset) {
            return offset.y + getPipeUnionHeight(d) > d.links.link1.yPipe || offset.y - getPipeUnionPosition(d) < d.links.link2.yPipe;
        };
        var offset = getOffset(d, 2, outLimit, oldOffset);
        traceAux_V_BR_H_LT_V(d, d.links.link1.xPipe, d.links.link1.yPipe, width, height, offset);
        return d;
    };

    //           _
    //         1|_|
    //           |
    //    _______|
    //   |
    //   |
    //   -
    // 2|_|
    //
    var pipeTrace_BT_RL_D = function (d, oldOffset) {
        var width = d.links.link1.xPipe - d.links.link2.xPipe;
        var height = d.links.link2.yPipe - d.links.link1.yPipe;
        var outLimit = function (offset) {
            return offset.y + getPipeUnionHeight(d) > d.links.link2.yPipe || offset.y - getPipeUnionPosition(d) < d.links.link1.yPipe;
        };
        var offset = getOffset(d, 2, outLimit, oldOffset);
        traceAux_V_BR_H_LT_V(d, d.links.link2.xPipe, d.links.link2.yPipe, width, height, offset);
        return d;
    };

    //   _
    // 1|_|
    //   |
    //   |______
    //          |
    //          |
    //          -
    //        2|_|
    //
    var pipeTrace_BT_LR_D = function (d, oldOffset) {
        var width = d.links.link2.xPipe - d.links.link1.xPipe;
        var height = d.links.link2.yPipe - d.links.link1.yPipe;
        var outLimit = function (offset) {
            return offset.y + getPipeUnionHeight(d) > d.links.link2.yPipe ||
                offset.y - getPipeUnionPosition(d) < d.links.link1.yPipe;
        };
        var offset = getOffset(d, 2, outLimit, oldOffset);
        traceAux_V_TR_H_LB_V(d, d.links.link1.xPipe, d.links.link1.yPipe, width, height, offset);
        return d;
    };

    //   _
    // 2|_|
    //   |
    //   |______
    //          |
    //          |
    //          -
    //        1|_|
    //
    var pipeTrace_TB_RL_U = function (d, oldOffset) {
        var width = d.links.link1.xPipe - d.links.link2.xPipe;
        var height = d.links.link1.yPipe - d.links.link2.yPipe;
        var outLimit = function (offset) {
            return offset.y + getPipeUnionHeight(d) > d.links.link1.yPipe ||
                offset.y - getPipeUnionPosition(d) < d.links.link2.yPipe;
        };
        var offset = getOffset(d, 2, outLimit, oldOffset);
        traceAux_V_TR_H_LB_V(d, d.links.link2.xPipe, d.links.link2.yPipe, width, height, offset);
        return d;
    };

    //    _______
    //   |       |
    //   -       |
    // 1|_|      |
    //           |
    //           -
    //         2|_|
    //
    var pipeTrace_TT_LR_D = function (d, oldOffset) {
        var width = d.links.link2.xPipe - d.links.link1.xPipe - getPipeUnionPosition(d);
        var y1 = d.links.link1.yPipe - getPipeUnionHeight(d);
        var h1 = getPipeUnionHeight(d);
        var x2 = d.links.link2.xPipe - getPipeUnionPosition(d);

        var outLimit1 = function (offset) {
            return offset.y > d.links.link1.yPipe - getPipeUnionHeight(d) || offset.y < 0;
        };
        var offset = getOffset(d, 2, outLimit1, oldOffset);
        if (offset) {
            y1 = offset.y;
            h1 = d.links.link1.yPipe - y1;
        }

        var y2 = y1;
        var h2 = d.links.link2.yPipe - y2;
        traceAux_BR_V_H(d, d.links.link1.xPipe, y1, width, h1);
        traceAux_LB_V(d, x2, y2, h2);
        return d;
    };

    //    _______
    //   |       |
    //   -       |
    // 2|_|      |
    //           |
    //           -
    //         1|_|
    //
    var pipeTrace_TT_RL_U = function (d, oldOffset) {
        var width = d.links.link1.xPipe - d.links.link2.xPipe - getPipeUnionPosition(d);
        var y1 = d.links.link2.yPipe - getPipeUnionHeight(d);
        var h1 = getPipeUnionHeight(d);
        var x2 = d.links.link1.xPipe - getPipeUnionPosition(d);

        var outLimit1 = function (offset) {
            return offset.y > d.links.link2.yPipe - getPipeUnionHeight(d) || offset.y < 0;
        };
        var offset = getOffset(d, 2, outLimit1, oldOffset);
        if (offset) {
            y1 = offset.y;
            h1 = d.links.link2.yPipe - y1;
        }

        var y2 = y1;
        var h2 = d.links.link1.yPipe - y2;
        traceAux_BR_V_H(d, d.links.link2.xPipe, y1, width, h1);
        traceAux_LB_V(d, x2, y2, h2);
        return d;
    };

    //    _______
    //   |       |
    //   |       -
    //   |     2|_|
    //   |
    //   -
    // 1|_|
    //
    var pipeTrace_TT_LR_U = function (d, oldOffset) {
        var width = d.links.link2.xPipe - d.links.link1.xPipe - getPipeUnionPosition(d);
        var y2 = d.links.link2.yPipe - getPipeUnionHeight(d);
        var h2 = getPipeUnionHeight(d);
        var x2 = d.links.link2.xPipe - getPipeUnionPosition(d);

        var outLimit1 = function (offset) {
            return offset.y > d.links.link2.yPipe - getPipeUnionHeight(d) || offset.y < 0;
        };
        var offset = getOffset(d, 2, outLimit1, oldOffset);
        if (offset) {
            y2 = offset.y;
            h2 = d.links.link2.yPipe - y2;
        }

        var y1 = y2;
        var h1 = d.links.link1.yPipe - y2;

        traceAux_BR_V_H(d, d.links.link1.xPipe, y1, width, h1);
        traceAux_LB_V(d, x2, y2, h2);
        return d;
    };

    //    _______
    //   |       |
    //   |       -
    //   |     1|_|
    //   |
    //   -
    // 2|_|
    //
    var pipeTrace_TT_RL_D = function (d, oldOffset) {
        var width = d.links.link1.xPipe - d.links.link2.xPipe - getPipeUnionPosition(d);
        var y2 = d.links.link1.yPipe - getPipeUnionHeight(d);
        var h2 = getPipeUnionHeight(d);
        var x2 = d.links.link1.xPipe - getPipeUnionPosition(d);

        var outLimit1 = function (offset) {
            return offset.y > d.links.link1.yPipe - getPipeUnionHeight(d) || offset.y < 0;
        };
        var offset = getOffset(d, 2, outLimit1, oldOffset);
        if (offset) {
            y2 = offset.y;
            h2 = d.links.link1.yPipe - y2;
        }

        var y1 = y2;
        var h1 = d.links.link2.yPipe - y2;

        traceAux_BR_V_H(d, d.links.link2.xPipe, y1, width, h1);
        traceAux_LB_V(d, x2, y2, h2);
        return d;
    };

    //         ___
    //        |   |
    //        -   |
    //      1|_|  |
    //         ___|
    //        |
    //        -
    //      2|_|
    //
    var pipeTrace_TT_V_D = function (d, oldOffset) {
        var height = d.links.link2.yPipe - d.links.link1.yPipe;
        var width = componentWidth;
        var x1 = d.links.link1.xPipe;
        var y1 = d.links.link1.yPipe - getPipeUnionHeight(d);
        var h1 = getPipeUnionHeight(d);
        var x2 = d.links.link2.xPipe;
        var y2 = d.links.link2.yPipe - getPipeUnionHeight(d);
        var h2 = getPipeUnionHeight(d);
        var x3 = d.links.link2.xPipe + width;

        var outLimit1 = function (offset) {
            return offset.y > d.links.link1.yPipe - getPipeUnionHeight(d) || offset.y < 0;
        };
        var offset = getOffset(d, 2, outLimit1, oldOffset);
        if (offset) {
            y1 = offset.y;
            h1 = d.links.link1.yPipe - y1;
        }
        var outLimit2 = function (offset) {
            return offset.x < d.links.link1.x + componentWidth;
        };
        offset = getOffset(d, 4, outLimit2, oldOffset);
        if (offset) {
            width = offset.x - d.links.link2.xPipe - getPipeUnionPosition(d);
            x3 = offset.x - getPipeUnionPosition(d);
        }
        var outLimit3 = function (offset) {
            return offset.y > d.links.link2.yPipe - getPipeUnionHeight(d) || offset.y < d.links.link1.y + componentHeight;
        };
        offset = getOffset(d, 8, outLimit3, oldOffset);
        if (offset) {
            y2 = offset.y;
            h2 = d.links.link2.yPipe - y2;
        }

        var h3 = height + h1 - h2 + getDefaultHeight(d);
        traceAux_BR_V_H(d, x1, y1, width, h1);
        traceAux_LB_V_LT(d, x3, y1, h3);
        traceAux_BR_V_H(d, x2, y2, width, h2);
        return d;
    };

    //         ___
    //        |   |
    //        -   |
    //      2|_|  |
    //         ___|
    //        |
    //        -
    //      1|_|
    //
    var pipeTrace_TT_V_U = function (d, oldOffset) {
        var height = d.links.link1.yPipe - d.links.link2.yPipe;
        var width = componentWidth;
        var x1 = d.links.link2.xPipe;
        var y1 = d.links.link2.yPipe - getPipeUnionHeight(d);
        var h1 = getPipeUnionHeight(d);
        var x2 = d.links.link1.xPipe;
        var y2 = d.links.link1.yPipe - getPipeUnionHeight(d);
        var h2 = getPipeUnionHeight(d);
        var x3 = d.links.link1.xPipe + width;

        var outLimit1 = function (offset) {
            return offset.y > d.links.link2.yPipe - getPipeUnionHeight(d) || offset.y < 0;
        };
        var offset = getOffset(d, 2, outLimit1, oldOffset);
        if (offset) {
            y1 = offset.y;
            h1 = d.links.link2.yPipe - y1;
        }
        var outLimit2 = function (offset) {
            return offset.x < d.links.link2.x + componentWidth;
        };
        offset = getOffset(d, 4, outLimit2, oldOffset);
        if (offset) {
            width = offset.x - d.links.link1.xPipe - getPipeUnionPosition(d);
            x3 = offset.x - getPipeUnionPosition(d);
        }
        var outLimit3 = function (offset) {
            return offset.y > d.links.link1.yPipe - getPipeUnionHeight(d) || offset.y < d.links.link2.y + componentHeight;
        };
        offset = getOffset(d, 8, outLimit3, oldOffset);
        if (offset) {
            y2 = offset.y;
            h2 = d.links.link1.yPipe - y2;
        }

        var h3 = height + h1 - h2 + getDefaultHeight(d);
        traceAux_BR_V_H(d, x1, y1, width, h1);
        traceAux_LB_V_LT(d, x3, y1, h3);
        traceAux_BR_V_H(d, x2, y2, width, h2);
        return d;
    };

    //   -
    // 1|_|
    //   |
    //   |        -
    //   |      2|_|
    //   |________|
    //
    //
    var pipeTrace_BB_LR_D = function (d, oldOffset) {
        var width = d.links.link2.xPipe - d.links.link1.xPipe - getPipeUnionPosition(d);
        var x1 = d.links.link1.xPipe;
        var y1 = d.links.link1.yPipe;
        var x2 = d.links.link2.xPipe;
        var y2 = d.links.link2.yPipe;
        var h2 = getPipeUnionHeight(d);

        var outLimit1 = function (offset) {
            return offset.y < d.links.link2.yPipe + getPipeUnionHeight(d);
        };
        var offset = getOffset(d, 2, outLimit1, oldOffset);
        if (offset) {
            h2 = offset.y - d.links.link2.yPipe;
        }

        var h1 = d.links.link2.yPipe - y1 + h2;

        traceAux_V_TR_H(d, x1, y1, width, h1);
        traceAux_V_LT(d, x2, y2, h2);
        return d;
    };

    //   -
    // 2|_|
    //   |
    //   |        -
    //   |      1|_|
    //   |________|
    //
    //
    var pipeTrace_BB_RL_U = function (d, oldOffset) {
        var width = d.links.link1.xPipe - d.links.link2.xPipe - getPipeUnionPosition(d);
        var x1 = d.links.link2.xPipe;
        var y1 = d.links.link2.yPipe;
        var x2 = d.links.link1.xPipe;
        var y2 = d.links.link1.yPipe;
        var h2 = getPipeUnionHeight(d);

        var outLimit1 = function (offset) {
            return offset.y < d.links.link1.yPipe + getPipeUnionHeight(d);
        };
        var offset = getOffset(d, 2, outLimit1, oldOffset);
        if (offset) {
            h2 = offset.y - d.links.link1.yPipe;
        }

        var h1 = d.links.link1.yPipe - y1 + h2;

        traceAux_V_TR_H(d, x1, y1, width, h1);
        traceAux_V_LT(d, x2, y2, h2);
        return d;
    };

    //            -
    //          2|_|
    //            |
    //   -        |
    // 1|_|       |
    //   |________|
    //
    //
    var pipeTrace_BB_LR_U = function (d, oldOffset) {
        var width = d.links.link2.xPipe - d.links.link1.xPipe - getPipeUnionPosition(d);
        var x1 = d.links.link1.xPipe;
        var y1 = d.links.link1.yPipe;
        var x2 = d.links.link2.xPipe;
        var y2 = d.links.link2.yPipe;
        var h1 = getPipeUnionHeight(d);

        var outLimit1 = function (offset) {
            return offset.y < d.links.link1.yPipe + getPipeUnionHeight(d);
        };
        var offset = getOffset(d, 2, outLimit1, oldOffset);
        if (offset) {
            h1 = offset.y - d.links.link1.yPipe;
        }

        var h2 = y1 - d.links.link2.yPipe + h1;

        traceAux_V_TR_H(d, x1, y1, width, h1);
        traceAux_V_LT(d, x2, y2, h2);
        return d;
    };

    //            -
    //          1|_|
    //            |
    //   -        |
    // 2|_|       |
    //   |________|
    //
    //
    var pipeTrace_BB_RL_D = function (d, oldOffset) {
        var width = d.links.link1.xPipe - d.links.link2.xPipe - getPipeUnionPosition(d);
        var x1 = d.links.link2.xPipe;
        var y1 = d.links.link2.yPipe;
        var x2 = d.links.link1.xPipe;
        var y2 = d.links.link1.yPipe;
        var h1 = getPipeUnionHeight(d);

        var outLimit1 = function (offset) {
            return offset.y < d.links.link2.yPipe + getPipeUnionHeight(d);
        };
        var offset = getOffset(d, 2, outLimit1, oldOffset);
        if (offset) {
            h1 = offset.y - d.links.link2.yPipe;
        }

        var h2 = y1 - d.links.link1.yPipe + h1;

        traceAux_V_TR_H(d, x1, y1, width, h1);
        traceAux_V_LT(d, x2, y2, h2);
        return d;
    };

    //        -
    //      1|_|
    //        |____
    //             |
    //        -    |
    //      2|_|   |
    //        |____|
    //
    var pipeTrace_BB_V_D = function (d, oldOffset) {
        var height = d.links.link2.yPipe - d.links.link1.yPipe;
        var width = componentWidth;
        var x1 = d.links.link1.xPipe;
        var y1 = d.links.link1.yPipe;
        var h1 = getPipeUnionHeight(d);
        var x2 = d.links.link2.xPipe;
        var y2 = d.links.link2.yPipe;
        var h2 = getPipeUnionHeight(d);
        var x3 = d.links.link2.xPipe + width;

        var outLimit1 = function (offset) {
            return offset.y < d.links.link1.yPipe + getPipeUnionHeight(d) || offset.y > d.links.link2.y;
        };
        var offset = getOffset(d, 2, outLimit1, oldOffset);
        if (offset) {
            h1 = offset.y - d.links.link1.yPipe;
        }
        var outLimit2 = function (offset) {
            return offset.x < d.links.link1.x + componentWidth;
        };
        offset = getOffset(d, 4, outLimit2, oldOffset);
        if (offset) {
            width = offset.x - d.links.link2.xPipe - getPipeUnionPosition(d);
            x3 = offset.x - getPipeUnionPosition(d);
        }
        var outLimit3 = function (offset) {
            return offset.y < d.links.link2.yPipe + getPipeUnionHeight(d);
        };
        offset = getOffset(d, 8, outLimit3, oldOffset);
        if (offset) {
            h2 = offset.y - d.links.link2.yPipe;
        }

        var y3 = y1 + h1 - getDefaultHeight(d);
        var h3 = height - h1 + h2 + getDefaultHeight(d);

        traceAux_V_TR_H(d, x1, y1, width, h1);
        traceAux_LB_V_LT(d, x3, y3, h3);
        traceAux_V_TR_H(d, x2, y2, width, h2);
        return d;
    };

    //        -
    //      2|_|
    //        |____
    //             |
    //        -    |
    //      1|_|   |
    //        |____|
    //
    var pipeTrace_BB_V_U = function (d, oldOffset) {
        var height = d.links.link1.yPipe - d.links.link2.yPipe;
        var width = componentWidth;
        var x1 = d.links.link2.xPipe;
        var y1 = d.links.link2.yPipe;
        var h1 = getPipeUnionHeight(d);
        var x2 = d.links.link1.xPipe;
        var y2 = d.links.link1.yPipe;
        var h2 = getPipeUnionHeight(d);
        var x3 = d.links.link1.xPipe + width;

        var outLimit1 = function (offset) {
            return offset.y < d.links.link2.yPipe + getPipeUnionHeight(d) || offset.y > d.links.link1.y;
        };
        var offset = getOffset(d, 2, outLimit1, oldOffset);
        if (offset) {
            h1 = offset.y - d.links.link2.yPipe;
        }
        var outLimit2 = function (offset) {
            return offset.x < d.links.link2.x + componentWidth;
        };
        offset = getOffset(d, 4, outLimit2, oldOffset);
        if (offset) {
            width = offset.x - d.links.link1.xPipe - getPipeUnionPosition(d);
            x3 = offset.x - getPipeUnionPosition(d);
        }
        var outLimit3 = function (offset) {
            return offset.y < d.links.link1.yPipe + getPipeUnionHeight(d);
        };
        offset = getOffset(d, 8, outLimit3, oldOffset);
        if (offset) {
            h2 = offset.y - d.links.link1.yPipe;
        }

        var y3 = y1 + h1 - getDefaultHeight(d);
        var h3 = height - h1 + h2 + getDefaultHeight(d);

        traceAux_V_TR_H(d, x1, y1, width, h1);
        traceAux_LB_V_LT(d, x3, y3, h3);
        traceAux_V_TR_H(d, x2, y2, width, h2);
        return d;
    };

    //    _______
    //   |       |
    //   -       |
    // 1|_|      |
    //           |
    //           |        _
    //            -------|_|2
    //
    var pipeTrace_TL_LR_D = function (d, oldOffset) {
        var width = d.links.link2.xPipe - d.links.link1.xPipe;
        var height = d.links.link2.yPipe - d.links.link1.yPipe;
        var x1 = d.links.link1.xPipe;
        var y1 = d.links.link1.yPipe - getPipeUnionHeight(d);
        var h1 = getPipeUnionHeight(d);
        var outLimit1 = function (offset) {
            return offset.y + getPipeUnionHeight(d) > d.links.link1.yPipe || offset.y < 0;
        };
        var offset = getOffset(d, 2, outLimit1, oldOffset);
        if (offset) {
            y1 = offset.y;
            h1 = d.links.link1.yPipe - y1;
        }
        var x2 = x1 + getPipeUnionWidth(d);
        var y2 = y1;
        var h2 = height + h1 + getDefaultHeight(d);
        var w2 = width - getPipeUnionWidth(d);
        var outLimit3 = function (offset) {
            return offset.x < d.links.link1.x + componentWidth ||
                offset.x > d.links.link2.x - getPipeUnionWidth(d);
        };
        offset = getOffset(d, 4, outLimit3, oldOffset);

        traceAux_BR_V(d, x1, y1, h1);
        traceAux_H_LB_V_TR_H(d, x2, y2, w2, h2, offset);
        return d;
    };

    //            _
    //    -------|_|2
    //   |
    //   -
    // 1|_|
    //
    var pipeTrace_TL_LR_U = function (d, oldOffset) {
        var width = d.links.link2.xPipe - d.links.link1.xPipe;
        var x1 = d.links.link1.xPipe;
        var y1 = d.links.link2.yPipe;
        var h1 = d.links.link1.yPipe - d.links.link2.yPipe;
        var x2 = x1 + getPipeUnionWidth(d);
        var y2 = y1;
        var w2 = width - getPipeUnionWidth(d);
        traceAux_BR_V(d, x1, y1, h1);
        pipeTraceH(d, x2, y2, w2, true);
        return d;
    };

    //    -----------
    //   |           |
    //   |        -  |
    //   |      2|_|-
    //   |
    //   -
    // 1|_|
    //
    var pipeTrace_TR_LR_U = function (d, oldOffset) {
        var width = d.links.link2.xPipe - d.links.link1.xPipe;
        var height = d.links.link1.yPipe - d.links.link2.y + getPipeUnionHeight(d);
        var x1 = d.links.link1.xPipe;
        var y1 = d.links.link1.yPipe - height;
        var h1 = height;
        var outLimit1 = function (offset) {
            return offset.y > d.links.link2.y - getPipeUnionHeight(d) || offset.y < 0;
        };
        var offset = getOffset(d, 2, outLimit1, oldOffset);
        if (offset) {
            y1 = offset.y;
            h1 = d.links.link1.yPipe - y1;
        }

        var outLimit2 = function (offset) {
            return offset.x < d.links.link2.xPipe + getPipeUnionPosition(d);
        };
        offset = getOffset(d, 4, outLimit2, oldOffset);
        if (offset) {
            width = offset.x - d.links.link1.xPipe - getPipeUnionPosition(d);
        }
        var w1 = width;
        var x2 = x1 + width;
        var y2 = y1;
        var h2 = d.links.link2.yPipe - y2 - getPipeUnionPosition(d);
        var x3 = d.links.link2.xPipe;
        var y3 = d.links.link2.yPipe - getPipeUnionPosition(d);
        var w3 = x2 - d.links.link2.xPipe + getPipeUnionPosition(d);
        traceAux_BR_V_H(d, x1, y1, w1, h1);
        traceAux_LB_V(d, x2, y2, h2);
        traceAux_H_LT(d, x3, y3, w3);
        return d;
    };

    //    -----------
    //   |           |
    //   -           |
    // 1|_|          |
    //               |
    //            -  |
    //          2|_|-
    //
    var pipeTrace_TR_LR_D = function (d, oldOffset) {
        var width = d.links.link2.xPipe - d.links.link1.xPipe;
        var x1 = d.links.link1.xPipe;
        var h1 = getPipeUnionHeight(d);
        var y1 = d.links.link1.yPipe - h1;

        var outLimit1 = function (offset) {
            return offset.y > d.links.link2.y - getPipeUnionHeight(d) || offset.y < 0;
        };
        var offset = getOffset(d, 2, outLimit1, oldOffset);
        if (offset) {
            y1 = offset.y;
            h1 = d.links.link1.yPipe - y1;
        }

        var outLimit2 = function (offset) {
            return offset.x < d.links.link2.xPipe + getPipeUnionPosition(d);
        };
        offset = getOffset(d, 4, outLimit2, oldOffset);
        if (offset) {
            width = offset.x - d.links.link1.xPipe - getPipeUnionPosition(d);
        }
        var w1 = width;
        var x2 = x1 + width;
        var y2 = y1;
        var h2 = d.links.link2.yPipe - y2 - getPipeUnionPosition(d);
        var x3 = d.links.link2.xPipe;
        var y3 = d.links.link2.yPipe - getPipeUnionPosition(d);
        var w3 = x2 - d.links.link2.xPipe + getPipeUnionPosition(d);
        traceAux_BR_V_H(d, x1, y1, w1, h1);
        traceAux_LB_V(d, x2, y2, h2);
        traceAux_H_LT(d, x3, y3, w3);
        return d;
    };

    //     -
    //   2|_|- ------------
    //                     |
    //                     -
    //                    |_|1
    //
    var pipeTrace_TR_RL_U = function (d, oldOffset) {
        var width = d.links.link1.xPipe - d.links.link2.xPipe;
        var x1 = d.links.link1.xPipe - getPipeUnionPosition(d);
        var y1 = d.links.link2.yPipe;
        var h1 = d.links.link1.yPipe - d.links.link2.yPipe;
        var x2 = d.links.link2.xPipe;
        var y2 = y1;
        var w2 = width - getPipeUnionPosition(d);
        traceAux_LB_V(d, x1, y1, h1);
        pipeTraceH(d, x2, y2, w2, false);
        return d;
    };

    //         ___________
    //        |            |
    //        |            -
    //        |           |_|1
    //     _  |
    //   2|_|-
    //
    var pipeTrace_TR_RL_D = function (d, oldOffset) {
        var x1 = d.links.link1.xPipe - getPipeUnionPosition(d);
        var h1 = getPipeUnionHeight(d);

        var x2 = d.links.link2.xPipe + getPipeUnionPosition(d);
        var outLimit1 = function (offset) {
            return offset.x > d.links.link1.x - getDefaultWidth(d) ||
                offset.x < d.links.link2.xPipe + getPipeUnionPosition(d);
        };
        var offset = getOffset(d, 3, outLimit1, oldOffset);
        if (offset) {
            x2 = offset.x;
        }
        var outLimit2 = function (offset) {
            return offset.y > d.links.link1.y - getPipeUnionHeight(d) ||
                offset.y < 0;
        };
        offset = getOffset(d, 4, outLimit2, oldOffset);
        if (offset) {
            h1 = d.links.link1.yPipe - offset.y;
        }
        var y1 = d.links.link1.yPipe - h1;
        var y2 = y1;
        var w2 = x1 - x2;
        var h2 = d.links.link2.yPipe - y2 - getPipeUnionPosition(d);
        var x3 = d.links.link2.xPipe;
        var y3 = d.links.link2.yPipe - getPipeUnionPosition(d);
        var w3 = x2 - x3;
        traceAux_LB_V(d, x1, y1, h1);
        traceAux_BR_V_H(d, x2, y2, w2, h2);
        traceAux_H_LT(d, x3, y3, w3);
        return d;
    };


    //     _
    //   -|_|1
    //  |
    //  |
    //   -------
    //          |
    //          -
    //         |_|2
    //
    var pipeTrace_LT_LR_D = function (d, oldOffset) {
        var x1 = d.links.link1.xPipe - getPipeUnionWidth(d);
        var y1 = d.links.link1.yPipe + getPipeUnionHeight(d);
        var w1 = getPipeUnionWidth(d);
        var height = d.links.link2.yPipe - y1;
        var outLimit1 = function (offset) {
            return offset.x > d.links.link1.xPipe - getPipeUnionWidth(d) ||
                offset.x < 0;
        };
        var offset = getOffset(d, 2, outLimit1, oldOffset);
        if (offset) {
            x1 = offset.x;
            w1 = d.links.link1.xPipe - x1;
        }
        var width = d.links.link2.xPipe - x1;
        var outLimit2 = function (offset) {
            return offset.y > d.links.link2.yPipe - getPipeUnionHeight(d) ||
                offset.y < d.links.link1.yPipe + getPipeUnionHeight(d) + getPipeUnionPosition(d);
        };
        offset = getOffset(d, 4, outLimit2, oldOffset);
        traceAux_BR_H(d, x1, y1, w1);
        traceAux_V_TR_H_LB_V(d, x1, y1, width, height, offset);
        return d;
    };

    //     _
    //   -|_|2
    //  |
    //  |
    //   -------
    //          |
    //          -
    //         |_|1
    //
    var pipeTrace_TL_RL_U = function (d, oldOffset) {
        var x1 = d.links.link2.xPipe - getPipeUnionWidth(d);
        var y1 = d.links.link2.yPipe + getPipeUnionHeight(d);
        var w1 = getPipeUnionWidth(d);
        var height = d.links.link1.yPipe - y1;
        var outLimit1 = function (offset) {
            return offset.x > d.links.link2.xPipe - getPipeUnionWidth(d) ||
                offset.x < 0;
        };
        var offset = getOffset(d, 2, outLimit1, oldOffset);
        if (offset) {
            x1 = offset.x;
            w1 = d.links.link2.xPipe - x1;
        }
        var width = d.links.link1.xPipe - x1;
        var outLimit2 = function (offset) {
            return offset.y > d.links.link1.yPipe - getPipeUnionHeight(d) ||
                offset.y < d.links.link2.yPipe + getPipeUnionHeight(d) + getPipeUnionPosition(d);
        };
        offset = getOffset(d, 4, outLimit2, oldOffset);
        traceAux_BR_H(d, x1, y1, w1);
        traceAux_V_TR_H_LB_V(d, x1, y1, width, height, offset);
        return d;
    };

    //   ___________
    //  |            |
    //  |            -
    //  |           |_|1
    //  |  _
    //   -|_|2
    //
    var pipeTrace_TL_RL_D = function (d, oldOffset) {
        var x1 = d.links.link1.xPipe - getPipeUnionPosition(d);
        var y1 = d.links.link1.yPipe - getPipeUnionHeight(d);
        var h1 = getPipeUnionHeight(d);
        var x2 = d.links.link2.xPipe - getPipeUnionWidth(d);
        var y2 = d.links.link2.yPipe - getPipeUnionPosition(d);
        var w3 = getPipeUnionWidth(d);
        var outLimit1 = function (offset) {
            return offset.y > d.links.link1.y - getPipeUnionHeight(d) ||
                offset.y < 0;
        };
        var offset1 = getOffset(d, 4, outLimit1, oldOffset);
        if (offset1) {
            y1 = offset1.y;
            h1 = d.links.link1.yPipe - y1;
        }
        var outLimit2 = function (offset) {
            return offset.x > d.links.link2.xPipe - getPipeUnionWidth(d) ||
                offset.x < 0;
        };
        var offset2 = getOffset(d, 3, outLimit2, oldOffset);
        if (offset2) {
            x2 = offset2.x;
            w3 = d.links.link2.xPipe - x2;
        }
        var width = x1 - x2;
        var height = y2 - y1;// + getPipeUnionHeight(d) - getPipeUnionPosition(d)
        traceAux_LB_V(d, x1, y1, h1);
        traceAux_BR_V_H(d, x2, y1, width, height);
        traceAux_TR_H(d, x2, y2, w3);
        return d;
    };



    //            _
    //    -------|_|1
    //   |
    //   -
    // 2|_|
    //
    var pipeTrace_LT_RL_D = function (d, oldOffset) {
        var width = d.links.link1.xPipe - d.links.link2.xPipe;
        var x1 = d.links.link2.xPipe;
        var y1 = d.links.link1.yPipe;
        var h1 = d.links.link2.yPipe - d.links.link1.yPipe;
        var x2 = x1 + getPipeUnionWidth(d);
        var y2 = y1;
        var w2 = width - getPipeUnionWidth(d);
        traceAux_BR_V(d, x1, y1, h1);
        pipeTraceH(d, x2, y2, w2, true);
        return d;
    };

    //    _______
    //   |       |
    //   -       |
    // 2|_|      |
    //           |
    //           |        _
    //            -------|_|1
    //
    var pipeTrace_LT_RL_U = function (d, oldOffset) {
        var width = d.links.link1.xPipe - d.links.link2.xPipe;
        var height = d.links.link1.yPipe - d.links.link2.yPipe;
        var x1 = d.links.link2.xPipe;
        var y1 = d.links.link2.yPipe - getPipeUnionHeight(d);
        var h1 = getPipeUnionHeight(d);
        var outLimit1 = function (offset) {
            return offset.y + getPipeUnionHeight(d) > d.links.link2.yPipe || offset.y < 0;
        };
        var offset = getOffset(d, 2, outLimit1, oldOffset);
        if (offset) {
            y1 = offset.y;
            h1 = d.links.link2.yPipe - y1;
        }
        var x2 = x1 + getPipeUnionWidth(d);
        var y2 = y1;
        var h2 = height + h1 + getDefaultHeight(d);
        var w2 = width - getPipeUnionWidth(d);
        var outLimit3 = function (offset) {
            return offset.x < d.links.link2.x + componentWidth ||
                offset.x > d.links.link1.x - getPipeUnionWidth(d);
        };
        offset = getOffset(d, 4, outLimit3, oldOffset);

        traceAux_BR_V(d, x1, y1, h1);
        traceAux_H_LB_V_TR_H(d, x2, y2, w2, h2, offset);
        return d;
    };

    //   ___________
    //  |            |
    //  |            -
    //  |           |_|2
    //  |  _
    //   -|_|1
    //
    var pipeTrace_LT_LR_U = function (d, oldOffset) {
        var x1 = d.links.link2.xPipe - getPipeUnionPosition(d);
        var y1 = d.links.link2.yPipe - getPipeUnionHeight(d);
        var h1 = getPipeUnionHeight(d);
        var x2 = d.links.link1.xPipe - getPipeUnionWidth(d);
        var y2 = d.links.link1.yPipe - getPipeUnionPosition(d);
        var w3 = getPipeUnionWidth(d);
        var outLimit1 = function (offset) {
            return offset.y > d.links.link2.y - getPipeUnionHeight(d) ||
                offset.y < 0;
        };
        var offset1 = getOffset(d, 4, outLimit1, oldOffset);
        if (offset1) {
            y1 = offset1.y;
            h1 = d.links.link2.yPipe - y1;
        }
        var outLimit2 = function (offset) {
            return offset.x > d.links.link1.xPipe - getPipeUnionWidth(d) ||
                offset.x < 0;
        };
        var offset2 = getOffset(d, 3, outLimit2, oldOffset);
        if (offset2) {
            x2 = offset2.x;
            w3 = d.links.link1.xPipe - x2;
        }
        var width = x1 - x2;
        var height = y2 - y1;
        traceAux_LB_V(d, x1, y1, h1);
        traceAux_BR_V_H(d, x2, y1, width, height);
        traceAux_TR_H(d, x2, y2, w3);
        return d;
    };

    //    -----------
    //   |           |
    //   |        -  |
    //   |      1|_|-
    //   |
    //   -
    // 2|_|
    //
    var pipeTrace_RT_RL_D = function (d, oldOffset) {
        var width = d.links.link1.xPipe - d.links.link2.xPipe;
        var height = d.links.link2.yPipe - d.links.link1.y + getPipeUnionHeight(d);
        var x1 = d.links.link2.xPipe;
        var y1 = d.links.link2.yPipe - height;
        var h1 = height;
        var outLimit1 = function (offset) {
            return offset.y > d.links.link1.y - getPipeUnionHeight(d) || offset.y < 0;
        };
        var offset = getOffset(d, 2, outLimit1, oldOffset);
        if (offset) {
            y1 = offset.y;
            h1 = d.links.link2.yPipe - y1;
        }

        var outLimit2 = function (offset) {
            return offset.x < d.links.link1.xPipe + getPipeUnionPosition(d);
        };
        offset = getOffset(d, 4, outLimit2, oldOffset);
        if (offset) {
            width = offset.x - d.links.link2.xPipe - getPipeUnionPosition(d);
        }
        var w1 = width;
        var x2 = x1 + width;
        var y2 = y1;
        var h2 = d.links.link1.yPipe - y2 - getPipeUnionPosition(d);
        var x3 = d.links.link1.xPipe;
        var y3 = d.links.link1.yPipe - getPipeUnionPosition(d);
        var w3 = x2 - d.links.link1.xPipe + getPipeUnionPosition(d);
        traceAux_BR_V_H(d, x1, y1, w1, h1);
        traceAux_LB_V(d, x2, y2, h2);
        traceAux_H_LT(d, x3, y3, w3);
        return d;
    };

    //    -----------
    //   |           |
    //   -           |
    // 2|_|          |
    //               |
    //            -  |
    //          1|_|-
    //
    var pipeTrace_RT_RL_U = function (d, oldOffset) {
        var width = d.links.link1.xPipe - d.links.link2.xPipe;
        var x1 = d.links.link2.xPipe;
        var h1 = getPipeUnionHeight(d);
        var y1 = d.links.link2.yPipe - h1;

        var outLimit1 = function (offset) {
            return offset.y > d.links.link1.y - getPipeUnionHeight(d) || offset.y < 0;
        };
        var offset = getOffset(d, 2, outLimit1, oldOffset);
        if (offset) {
            y1 = offset.y;
            h1 = d.links.link2.yPipe - y1;
        }

        var outLimit2 = function (offset) {
            return offset.x < d.links.link1.xPipe + getPipeUnionPosition(d);
        };
        offset = getOffset(d, 4, outLimit2, oldOffset);
        if (offset) {
            width = offset.x - d.links.link2.xPipe - getPipeUnionPosition(d);
        }
        var w1 = width;
        var x2 = x1 + width;
        var y2 = y1;
        var h2 = d.links.link1.yPipe - y2 - getPipeUnionPosition(d);
        var x3 = d.links.link1.xPipe;
        var y3 = d.links.link1.yPipe - getPipeUnionPosition(d);
        var w3 = x2 - d.links.link1.xPipe + getPipeUnionPosition(d);
        traceAux_BR_V_H(d, x1, y1, w1, h1);
        traceAux_LB_V(d, x2, y2, h2);
        traceAux_H_LT(d, x3, y3, w3);
        return d;
    };

    //     -
    //   2|_|- ------------
    //                     |
    //                     -
    //                    |_|1
    //
    var pipeTrace_RT_LR_D = function (d, oldOffset) {
        var width = d.links.link2.xPipe - d.links.link1.xPipe;
        var x1 = d.links.link2.xPipe - getPipeUnionPosition(d);
        var y1 = d.links.link1.yPipe;
        var h1 = d.links.link2.yPipe - d.links.link1.yPipe;
        var x2 = d.links.link1.xPipe;
        var y2 = y1;
        var w2 = width - getPipeUnionPosition(d);
        traceAux_LB_V(d, x1, y1, h1);
        pipeTraceH(d, x2, y2, w2, false);
        return d;
    };

    //         ___________
    //        |            |
    //        |            -
    //        |           |_|2
    //     _  |
    //   1|_|-
    //
    var pipeTrace_RT_LR_U = function (d, oldOffset) {
        var x1 = d.links.link2.xPipe - getPipeUnionPosition(d);
        var h1 = getPipeUnionHeight(d);

        var x2 = d.links.link1.xPipe + getPipeUnionPosition(d);
        var outLimit1 = function (offset) {
            return offset.x > d.links.link2.x - getDefaultWidth(d) ||
                offset.x < d.links.link1.xPipe + getPipeUnionPosition(d);
        };
        var offset = getOffset(d, 3, outLimit1, oldOffset);
        if (offset) {
            x2 = offset.x;
        }
        var outLimit2 = function (offset) {
            return offset.y > d.links.link2.y - getPipeUnionHeight(d) ||
                offset.y < 0;
        };
        offset = getOffset(d, 4, outLimit2, oldOffset);
        if (offset) {
            h1 = d.links.link2.yPipe - offset.y;
        }
        var y1 = d.links.link2.yPipe - h1;
        var y2 = y1;
        var w2 = x1 - x2;
        var h2 = d.links.link1.yPipe - y2 - getPipeUnionPosition(d);
        var x3 = d.links.link1.xPipe;
        var y3 = d.links.link1.yPipe - getPipeUnionPosition(d);
        var w3 = x2 - x3;
        traceAux_LB_V(d, x1, y1, h1);
        traceAux_BR_V_H(d, x2, y2, w2, h2);
        traceAux_H_LT(d, x3, y3, w3);
        return d;
    };

    //            _
    //          -|_|2
    //         |
    //   _     |
    // 1|_|    |
    //   |     |
    //    -----
    var pipeTrace_BL_LR_U = function (d, oldOffset) {
        var x1 = d.links.link1.xPipe;
        var y1 = d.links.link1.yPipe;
        var h1 = getPipeUnionHeight(d);
        var outLimit1 = function (offset) {
            return offset.y < d.links.link1.yPipe + getPipeUnionHeight(d);
        };
        var offset = getOffset(d, 2, outLimit1, oldOffset);
        if (offset) {
            h1 = offset.y - d.links.link1.yPipe;
        }
        var x2 = x1 + getPipeUnionWidth(d);
        var y2 = y1 + h1 - getPipeUnionHeight(d) + getPipeUnionPosition(d);
        var w2 = d.links.link2.xPipe - x2 + getPipeUnionWidth(d);
        var h2 = y2 - d.links.link2.yPipe + getPipeUnionHeight(d) - getPipeUnionPosition(d);
        var outLimit2 = function (offset) {
            return offset.x < d.links.link1.xPipe + getPipeUnionWidth(d) ||
                offset.x > d.links.link2.xPipe - getPipeUnionWidth(d);
        };
        offset = getOffset(d, 3, outLimit2, oldOffset);
        traceAux_V_TR(d, x1, y1, h1);
        traceAux_H_LT_V_TR_H(d, x2, y2, w2, h2, offset);
        return d;
    };

    //      _
    //    1|_|
    //      |
    //      |          _
    //       ------- -|_|2
    //
    var pipeTrace_BL_LR_D = function (d, oldOffset) {
        var x1 = d.links.link1.xPipe;
        var y1 = d.links.link1.yPipe;
        var h1 = d.links.link2.yPipe - d.links.link1.yPipe + getPipeUnionHeight(d) - getPipeUnionPosition(d);
        var x2 = x1 + getPipeUnionWidth(d);
        var y2 = y1 + h1 - getPipeUnionHeight(d) + getPipeUnionPosition(d);
        var w2 = d.links.link2.xPipe - x2;
        traceAux_V_TR(d, x1, y1, h1);
        pipeTraceH(d, x2, y2, w2, false);
        return d;
    };

    //            _
    //          2|_|-
    //               |
    //   _           |
    // 1|_|          |
    //   |           |
    //    -----------
    //
    var pipeTrace_BR_LR_U = function (d, oldOffset) {
        var x1 = d.links.link1.xPipe;
        var y1 = d.links.link1.yPipe;
        var h1 = getPipeUnionHeight(d);

        var y2 = d.links.link2.yPipe;
        var w2 = getPipeUnionWidth(d);

        var outLimit1 = function (offset) {
            return offset.x < d.links.link2.xPipe + getPipeUnionWidth(d) ||
                offset.x < 0;
        };
        var offset = getOffset(d, 4, outLimit1, oldOffset);
        if (offset) {
            w2 = offset.x - d.links.link2.xPipe;
        }

        var x2 = d.links.link2.xPipe;
        var x3 = x2 + w2 - getDefaultWidth(d);
        var y3 = y2 + getPipeUnionHeight(d);
        var w3 = x3 - x1 - getPipeUnionHeight(d) - getPipeUnionPosition(d);
        var outLimit2 = function (offset) {
            return offset.y < d.links.link1.yPipe + getPipeUnionHeight(d);
        };
        offset = getOffset(d, 6, outLimit2, oldOffset);
        if (offset) {
            h1 = offset.y - d.links.link1.yPipe;
        }
        var h3 = y1 - y2 + h1 - getPipeUnionHeight(d);
        traceAux_V_TR(d, x1, y1, h1);
        traceAux_H_LB(d, x2, y2, w2);
        traceAux_V_LT_H(d, x3, y3, w3, h3);
        return d;
    };

    //   _
    // 1|_|
    //   |
    //   |        _
    //   |      2|_|-
    //   |           |
    //    -----------
    //
    var pipeTrace_BR_LR_D = function (d, oldOffset) {
        var x1 = d.links.link1.xPipe;
        var y1 = d.links.link1.yPipe;

        var y2 = d.links.link2.yPipe;
        var w2 = getPipeUnionWidth(d);

        var outLimit1 = function (offset) {
            return offset.x < d.links.link2.xPipe + getPipeUnionWidth(d) ||
                offset.x < 0;
        };
        var offset = getOffset(d, 4, outLimit1, oldOffset);
        if (offset) {
            w2 = offset.x - d.links.link2.xPipe;
        }

        var x2 = d.links.link2.xPipe;
        var x3 = x2 + w2 - getDefaultWidth(d);
        var y3 = y2 + getPipeUnionHeight(d);
        var w3 = x3 - x1 - getPipeUnionHeight(d) - getPipeUnionPosition(d);
        var h1 = y3 - d.links.link1.yPipe + getPipeUnionHeight(d);
        var outLimit2 = function (offset) {
            return offset.y < d.links.link2.yPipe + (2 * getPipeUnionHeight(d));
        };
        offset = getOffset(d, 6, outLimit2, oldOffset);
        if (offset) {
            h1 = offset.y - d.links.link1.yPipe;
        }
        var h3 = h1 - (y3 - d.links.link1.yPipe);
        traceAux_V_TR(d, x1, y1, h1);
        traceAux_H_LB(d, x2, y2, w2);
        traceAux_V_LT_H(d, x3, y3, w3, h3);
        return d;
    };

    //      _
    //    -|_|2
    //   |
    //   |        _
    //   |      1|_|
    //   |        |
    //    --------
    //
    var pipeTrace_BL_RL_U = function (d, oldOffset) {
        var x1 = d.links.link1.xPipe;
        var y1 = d.links.link1.yPipe;
        var h1 = getPipeUnionHeight(d);

        var y2 = d.links.link2.yPipe + getPipeUnionHeight(d);
        var w2 = getPipeUnionWidth(d);

        var outLimit1 = function (offset) {
            return offset.x > d.links.link2.xPipe - getPipeUnionWidth(d) ||
                offset.x < 0;
        };
        var offset = getOffset(d, 4, outLimit1, oldOffset);
        if (offset) {
            w2 = d.links.link2.xPipe - offset.x;
        }

        var x2 = d.links.link2.xPipe - w2;
        var x3 = x2;
        var y3 = y2;
        var w3 = x1 - x2 - getPipeUnionPosition(d);
        var outLimit2 = function (offset) {
            return offset.y < d.links.link1.yPipe + getPipeUnionHeight(d);
        };
        offset = getOffset(d, 6, outLimit2, oldOffset);
        if (offset) {
            h1 = offset.y - d.links.link1.yPipe;
        }
        var h3 = y1 - y2 + h1;
        traceAux_V_LT(d, x1, y1, h1);
        traceAux_BR_H(d, x2, y2, w2);
        traceAux_V_TR_H(d, x3, y3, w3, h3);
        return d;
    };

    //
    //          _
    //        1|_|
    //          |
    //    _     |
    //  -|_|2   |
    // |        |
    //  --------
    //
    var pipeTrace_BL_RL_D = function (d, oldOffset) {
        var x1 = d.links.link1.xPipe;
        var y1 = d.links.link1.yPipe;
        var y2 = d.links.link2.yPipe + getPipeUnionHeight(d);
        var w2 = getPipeUnionWidth(d);

        var outLimit1 = function (offset) {
            return offset.x > d.links.link2.xPipe - getPipeUnionWidth(d) ||
                offset.x < 0;
        };
        var offset = getOffset(d, 4, outLimit1, oldOffset);
        if (offset) {
            w2 = d.links.link2.xPipe - offset.x;
        }

        var x2 = d.links.link2.xPipe - w2;
        var x3 = x2;
        var y3 = y2;
        var w3 = x1 - x2 - getPipeUnionPosition(d);
        var h1 = y3 - d.links.link1.yPipe + getPipeUnionHeight(d);
        var outLimit2 = function (offset) {
            return offset.y < d.links.link2.yPipe + (2 * getPipeUnionHeight(d));
        };
        offset = getOffset(d, 6, outLimit2, oldOffset);
        if (offset) {
            h1 = offset.y - d.links.link1.yPipe;
        }
        var h3 = h1 - (y3 - d.links.link1.yPipe);
        traceAux_V_LT(d, x1, y1, h1);
        traceAux_BR_H(d, x2, y2, w2);
        traceAux_V_TR_H(d, x3, y3, w3, h3);
        return d;
    };

    //     _
    //   2|_|-
    //        |
    //        |        _
    //        |      1|_|
    //        |        |
    //         --------
    //
    var pipeTrace_BR_RL_U = function (d, oldOffset) {
        var x1 = d.links.link1.xPipe;
        var y1 = d.links.link1.yPipe;
        var h1 = getPipeUnionHeight(d);

        var y2 = d.links.link2.yPipe;
        var w2 = getPipeUnionWidth(d);

        var outLimit1 = function (offset) {
            return offset.x > d.links.link1.xPipe - getPipeUnionWidth(d) ||
                offset.x < d.links.link2.xPipe + getPipeUnionWidth(d);
        };
        var offset = getOffset(d, 4, outLimit1, oldOffset);
        if (offset) {
            w2 = offset.x - d.links.link2.xPipe;
        }

        var x2 = d.links.link2.xPipe;
        var x3 = x2 + w2 - getPipeUnionWidth(d) + getPipeUnionPosition(d);
        var y3 = y2 + getPipeUnionHeight(d);
        var w3 = x1 - x3 - getPipeUnionPosition(d);
        var outLimit2 = function (offset) {
            return offset.y < d.links.link1.yPipe + getPipeUnionHeight(d);
        };
        offset = getOffset(d, 6, outLimit2, oldOffset);
        if (offset) {
            h1 = offset.y - d.links.link1.yPipe;
        }
        var h3 = y1 - y3 + h1;
        traceAux_V_LT(d, x1, y1, h1);
        traceAux_H_LB(d, x2, y2, w2);
        traceAux_V_TR_H(d, x3, y3, w3, h3);
        return d;
    };

    //                _
    //              1|_|
    //                |
    //      _         |
    //    2|_|--------
    //
    var pipeTrace_BR_RL_D = function (d, oldOffset) {
        var x1 = d.links.link1.xPipe;
        var y1 = d.links.link1.yPipe;
        var h1 = d.links.link2.yPipe - d.links.link1.yPipe + getPipeUnionHeight(d) - getPipeUnionPosition(d);
        var x2 = d.links.link2.xPipe;
        var y2 = d.links.link2.yPipe;
        var w2 = x1 - x2 - getPipeUnionPosition(d);
        traceAux_V_LT(d, x1, y1, h1);
        pipeTraceH(d, x2, y2, w2, false);
        return d;
    };

    //            _
    //          -|_|1
    //         |
    //   _     |
    // 2|_|    |
    //   |     |
    //    -----
    var pipeTrace_LB_RL_D = function (d, oldOffset) {
        var x1 = d.links.link2.xPipe;
        var y1 = d.links.link2.yPipe;
        var h1 = getPipeUnionHeight(d);
        var outLimit1 = function (offset) {
            return offset.y < d.links.link2.yPipe + getPipeUnionHeight(d);
        };
        var offset = getOffset(d, 2, outLimit1, oldOffset);
        if (offset) {
            h1 = offset.y - d.links.link2.yPipe;
        }
        var x2 = x1 + getPipeUnionWidth(d);
        var y2 = y1 + h1 - getPipeUnionHeight(d) + getPipeUnionPosition(d);
        var w2 = d.links.link1.xPipe - x2 + getPipeUnionWidth(d);
        var h2 = y2 - d.links.link1.yPipe + getPipeUnionHeight(d) - getPipeUnionPosition(d);
        var outLimit2 = function (offset) {
            return offset.x < d.links.link2.xPipe + getPipeUnionWidth(d) ||
                offset.x > d.links.link1.xPipe - getPipeUnionWidth(d);
        };
        offset = getOffset(d, 3, outLimit2, oldOffset);
        traceAux_V_TR(d, x1, y1, h1);
        traceAux_H_LT_V_TR_H(d, x2, y2, w2, h2, offset);
        return d;
    };

    //      _
    //    2|_|
    //      |
    //      |          _
    //       ------- -|_|1
    //
    var pipeTrace_LB_RL_U = function (d, oldOffset) {
        var x1 = d.links.link2.xPipe;
        var y1 = d.links.link2.yPipe;
        var h1 = d.links.link1.yPipe - d.links.link2.yPipe + getPipeUnionHeight(d) - getPipeUnionPosition(d);
        var x2 = x1 + getPipeUnionWidth(d);
        var y2 = y1 + h1 - getPipeUnionHeight(d) + getPipeUnionPosition(d);
        var w2 = d.links.link1.xPipe - x2;
        traceAux_V_TR(d, x1, y1, h1);
        pipeTraceH(d, x2, y2, w2, false);
        return d;
    };

    //            _
    //          1|_|-
    //               |
    //   _           |
    // 2|_|          |
    //   |           |
    //    -----------
    //
    var pipeTrace_RB_RL_D = function (d, oldOffset) {
        var x1 = d.links.link2.xPipe;
        var y1 = d.links.link2.yPipe;
        var h1 = getPipeUnionHeight(d);

        var y2 = d.links.link1.yPipe;
        var w2 = getPipeUnionWidth(d);

        var outLimit1 = function (offset) {
            return offset.x < d.links.link1.xPipe + getPipeUnionWidth(d) ||
                offset.x < 0;
        };
        var offset = getOffset(d, 4, outLimit1, oldOffset);
        if (offset) {
            w2 = offset.x - d.links.link1.xPipe;
        }

        var x2 = d.links.link1.xPipe;
        var x3 = x2 + w2 - getDefaultWidth(d);
        var y3 = y2 + getPipeUnionHeight(d);
        var w3 = x3 - x1 - getPipeUnionHeight(d) - getPipeUnionPosition(d);
        var outLimit2 = function (offset) {
            return offset.y < d.links.link2.yPipe + getPipeUnionHeight(d);
        };
        offset = getOffset(d, 6, outLimit2, oldOffset);
        if (offset) {
            h1 = offset.y - d.links.link2.yPipe;
        }
        var h3 = y1 - y2 + h1 - getPipeUnionHeight(d);
        traceAux_V_TR(d, x1, y1, h1);
        traceAux_H_LB(d, x2, y2, w2);
        traceAux_V_LT_H(d, x3, y3, w3, h3);
        return d;
    };

    //   _
    // 2|_|
    //   |
    //   |        _
    //   |      1|_|-
    //   |           |
    //    -----------
    //
    var pipeTrace_RB_RL_U = function (d, oldOffset) {
        var x1 = d.links.link2.xPipe;
        var y1 = d.links.link2.yPipe;

        var y2 = d.links.link1.yPipe;
        var w2 = getPipeUnionWidth(d);

        var outLimit1 = function (offset) {
            return offset.x < d.links.link1.xPipe + getPipeUnionWidth(d) ||
                offset.x < 0;
        };
        var offset = getOffset(d, 4, outLimit1, oldOffset);
        if (offset) {
            w2 = offset.x - d.links.link1.xPipe;
        }

        var x2 = d.links.link1.xPipe;
        var x3 = x2 + w2 - getDefaultWidth(d);
        var y3 = y2 + getPipeUnionHeight(d);
        var w3 = x3 - x1 - getPipeUnionHeight(d) - getPipeUnionPosition(d);
        var h1 = y3 - d.links.link2.yPipe + getPipeUnionHeight(d);
        var outLimit2 = function (offset) {
            return offset.y < d.links.link1.yPipe + (2 * getPipeUnionHeight(d));
        };
        offset = getOffset(d, 6, outLimit2, oldOffset);
        if (offset) {
            h1 = offset.y - d.links.link2.yPipe;
        }
        var h3 = h1 - (y3 - d.links.link2.yPipe);
        traceAux_V_TR(d, x1, y1, h1);
        traceAux_H_LB(d, x2, y2, w2);
        traceAux_V_LT_H(d, x3, y3, w3, h3);
        return d;
    };

    //      _
    //    -|_|1
    //   |
    //   |        _
    //   |      2|_|
    //   |        |
    //    --------
    //
    var pipeTrace_LB_LR_D = function (d, oldOffset) {
        var x1 = d.links.link2.xPipe;
        var y1 = d.links.link2.yPipe;
        var h1 = getPipeUnionHeight(d);

        var y2 = d.links.link1.yPipe + getPipeUnionHeight(d);
        var w2 = getPipeUnionWidth(d);

        var outLimit1 = function (offset) {
            return offset.x > d.links.link1.xPipe - getPipeUnionWidth(d) ||
                offset.x < 0;
        };
        var offset = getOffset(d, 4, outLimit1, oldOffset);
        if (offset) {
            w2 = d.links.link1.xPipe - offset.x;
        }

        var x2 = d.links.link1.xPipe - w2;
        var x3 = x2;
        var y3 = y2;
        var w3 = x1 - x2 - getPipeUnionPosition(d);
        var outLimit2 = function (offset) {
            return offset.y < d.links.link2.yPipe + getPipeUnionHeight(d);
        };
        offset = getOffset(d, 6, outLimit2, oldOffset);
        if (offset) {
            h1 = offset.y - d.links.link2.yPipe;
        }
        var h3 = y1 - y2 + h1;
        traceAux_V_LT(d, x1, y1, h1);
        traceAux_BR_H(d, x2, y2, w2);
        traceAux_V_TR_H(d, x3, y3, w3, h3);
        return d;
    };

    //
    //          _
    //        2|_|
    //          |
    //    _     |
    //  -|_|1   |
    // |        |
    //  --------
    //
    var pipeTrace_LB_LR_U = function (d, oldOffset) {
        var x1 = d.links.link2.xPipe;
        var y1 = d.links.link2.yPipe;
        var y2 = d.links.link1.yPipe + getPipeUnionHeight(d);
        var w2 = getPipeUnionWidth(d);

        var outLimit1 = function (offset) {
            return offset.x > d.links.link1.xPipe - getPipeUnionWidth(d) ||
                offset.x < 0;
        };
        var offset = getOffset(d, 4, outLimit1, oldOffset);
        if (offset) {
            w2 = d.links.link1.xPipe - offset.x;
        }

        var x2 = d.links.link1.xPipe - w2;
        var x3 = x2;
        var y3 = y2;
        var w3 = x1 - x2 - getPipeUnionPosition(d);
        var h1 = y3 - d.links.link2.yPipe + getPipeUnionHeight(d);
        var outLimit2 = function (offset) {
            return offset.y < d.links.link1.yPipe + (2 * getPipeUnionHeight(d));
        };
        offset = getOffset(d, 6, outLimit2, oldOffset);
        if (offset) {
            h1 = offset.y - d.links.link2.yPipe;
        }
        var h3 = h1 - (y3 - d.links.link2.yPipe);
        traceAux_V_LT(d, x1, y1, h1);
        traceAux_BR_H(d, x2, y2, w2);
        traceAux_V_TR_H(d, x3, y3, w3, h3);
        return d;
    };

    //     _
    //   1|_|-
    //        |
    //        |        _
    //        |      2|_|
    //        |        |
    //         --------
    //
    var pipeTrace_RB_LR_D = function (d, oldOffset) {
        var x1 = d.links.link2.xPipe;
        var y1 = d.links.link2.yPipe;
        var h1 = getPipeUnionHeight(d);

        var y2 = d.links.link1.yPipe;
        var w2 = getPipeUnionWidth(d);

        var outLimit1 = function (offset) {
            return offset.x > d.links.link2.xPipe - getPipeUnionWidth(d) ||
                offset.x < d.links.link1.xPipe + getPipeUnionWidth(d);
        };
        var offset = getOffset(d, 4, outLimit1, oldOffset);
        if (offset) {
            w2 = offset.x - d.links.link1.xPipe;
        }

        var x2 = d.links.link1.xPipe;
        var x3 = x2 + w2 - getPipeUnionWidth(d) + getPipeUnionPosition(d);
        var y3 = y2 + getPipeUnionHeight(d);
        var w3 = x1 - x3 - getPipeUnionPosition(d);
        var outLimit2 = function (offset) {
            return offset.y < d.links.link2.yPipe + getPipeUnionHeight(d);
        };
        offset = getOffset(d, 6, outLimit2, oldOffset);
        if (offset) {
            h1 = offset.y - d.links.link2.yPipe;
        }
        var h3 = y1 - y3 + h1;
        traceAux_V_LT(d, x1, y1, h1);
        traceAux_H_LB(d, x2, y2, w2);
        traceAux_V_TR_H(d, x3, y3, w3, h3);
        return d;
    };

    //                _
    //              2|_|
    //                |
    //      _         |
    //    1|_|--------
    //
    var pipeTrace_RB_LR_U = function (d, oldOffset) {
        var x1 = d.links.link2.xPipe;
        var y1 = d.links.link2.yPipe;
        var h1 = d.links.link1.yPipe - d.links.link2.yPipe + getPipeUnionHeight(d) - getPipeUnionPosition(d);
        var x2 = d.links.link1.xPipe;
        var y2 = d.links.link1.yPipe;
        var w2 = x1 - x2 - getPipeUnionPosition(d);
        traceAux_V_LT(d, x1, y1, h1);
        pipeTraceH(d, x2, y2, w2, false);
        return d;
    };

    // __
    //   |
    //   |
    //   |__
    //
    var pipeUnionTraceRLTB = function (d, x, y, height) {
        var effectiveHeight = height - getPipeUnionHeight(d) - getPipeUnionPosition(d);
        pipeUnionLB(d, x, y);
        pipeTraceV(d, x + getPipeUnionPosition(d), y + getPipeUnionHeight(d), effectiveHeight, true);
        pipeUnionTR(d, x + getPipeUnionPosition(d), y + getPipeUnionHeight(d) + effectiveHeight);
        return d;
    };

    //    __
    //   |
    //   |
    // __|
    //
    var pipeUnionTraceRLBT = function (d, x, y, height) {
        var effectiveHeight = height - getPipeUnionHeight(d) - getPipeUnionPosition(d);
        pipeUnionLT(d, x, y + getDefaultHeight(d) - getPipeUnionHeight(d));
        pipeTraceV(d, x + getPipeUnionPosition(d), y - effectiveHeight - getPipeUnionPosition(d), effectiveHeight, true);
        pipeUnionBR(d, x + getPipeUnionPosition(d), y - getPipeUnionPosition(d) - getPipeUnionHeight(d) - effectiveHeight);
        return d;
    };


    //
    //       |
    //  _____|
    // |
    // |
    //
    var pipeUnionTraceTB = function (d, x, y, width, height, offset) {
        pipeUnionLB(d, x, y);
        var height1 = height / 2 - (2 * getPipeUnionPosition(d) + getDefaultHeight(d));
        var height2 = height1;
        if (offset && offset.subIndex === 3) {
            height1 = offset.y - y - getPipeUnionHeight(d) - getPipeUnionPosition(d);
            height2 = height - height1 - (2 * getPipeUnionHeight(d) + getDefaultHeight(d));
        }
        pipeTraceV(d, x + getPipeUnionPosition(d), y + getPipeUnionHeight(d), height1, true);
        pipeUnionLT(d, x, y + getPipeUnionHeight(d) + height1);
        pipeTraceH(d,
            x - width,
            y + getPipeUnionHeight(d) + getPipeUnionPosition(d) + height1,
            width, true);
        var unionBRx = x - width - getPipeUnionWidth(d);
        var unionBRy = y + getPipeUnionHeight(d) + getPipeUnionPosition(d) + height1;
        pipeUnionBR(d, unionBRx, unionBRy);
        pipeTraceV(d, unionBRx, unionBRy + getPipeUnionHeight(d), height2, true);
        pipeUnionTR(d, unionBRx, y + height - getPipeUnionHeight(d) + getDefaultHeight(d));
        return d;
    };

    //
    // |
    // |_____
    //       |
    //       |
    //
    var pipeUnionTraceBT = function (d, x, y, width, height, offset) {
        pipeUnionLT(d, x, y - getPipeUnionPosition(d));
        var height1 = height / 2 - (2 * getPipeUnionPosition(d) + getDefaultHeight(d));
        var height2 = height1;
        if (offset && offset.subIndex === 3) {
            height1 = y - offset.y - getPipeUnionHeight(d) - getPipeUnionPosition(d);
            height2 = height - height1 - (2 * getPipeUnionHeight(d) + getDefaultHeight(d));
        }
        pipeTraceV(d, x + getPipeUnionPosition(d), y - height1 - getPipeUnionPosition(d), height1, true);
        pipeUnionLB(d,
            x + getPipeUnionPosition(d) - getPipeUnionPosition(d),
            y - height1 - getPipeUnionPosition(d) - getPipeUnionHeight(d));
        pipeTraceH(d,
            x - width,
            y - height1 - getPipeUnionPosition(d) - getPipeUnionHeight(d),
            width, true);
        var unionTRx = x - width - getPipeUnionWidth(d);
        var unionTRy = y - height1 - getPipeUnionPosition(d) - getPipeUnionHeight(d) - getPipeUnionPosition(d);
        pipeUnionTR(d, unionTRx, unionTRy);
        pipeTraceV(d, unionTRx, y - height + getPipeUnionHeight(d), height2, true);
        pipeUnionBR(d, x - width - getPipeUnionWidth(d), y - height);
        return d;
    };

    //  _____
    // |     |
    // |     |
    //
    var pipeUnionTraceHTT = function (d, x, y, width, height, offset) {
        if (offset && offset.subIndex === 2) {
            height = y - offset.y;
        }
        pipeTraceV(d,
            x,
            y - height,
            height, true);
        pipeUnionBR(d,
            x,
            y - height - getPipeUnionHeight(d));
        pipeTraceH(d,
            x + getPipeUnionWidth(d),
            y - height - getPipeUnionHeight(d),
            width - getPipeUnionWidth(d) - getPipeUnionPosition(d),
            true);
        pipeUnionLB(d,
            x + width - getPipeUnionPosition(d),
            y - height - getPipeUnionHeight(d));
        pipeTraceV(d,
            x + width,
            y - height,
            height,
            true);
        return d;
    };

    // ____
    //     |
    //     |
    // ____|
    //
    var pipeUnionTraceVRR = function (d, x, y, width, height, offset) {
        if (offset && offset.subIndex === 2) {
            width = offset.x - x;
        }
        pipeTraceH(d,
            x,
            y,
            width, true);
        pipeUnionLB(d,
            x + width,
            y);
        pipeTraceV(d,
            x + width + getPipeUnionPosition(d),
            y + getPipeUnionHeight(d),
            height - getPipeUnionHeight(d) - getPipeUnionPosition(d),
            true);
        pipeUnionLT(d,
            x + width,
            y + height - getPipeUnionPosition(d));
        pipeTraceH(d,
            x,
            y + height,
            width,
            true);
        return d;
    };

    //  _
    //   |
    //  _|
    //
    var pipeUnionTraceLL = function (d, x, y, height) {
        pipeUnionLB(d,
            x,
            y);
        pipeTraceV(d,
            x + getPipeUnionPosition(d),
            y + getPipeUnionHeight(d),
            height - getPipeUnionHeight(d) - getPipeUnionPosition(d),
            true);
        pipeUnionLT(d,
            x,
            y + height - getPipeUnionPosition(d));

        return d;
    };

    //  _
    // |
    // |_
    //
    var pipeUnionTraceRR = function (d, x, y, height) {
        pipeUnionBR(d,
            x - getPipeUnionWidth(d),
            y);
        pipeTraceV(d,
            x - getPipeUnionWidth(d),
            y + getPipeUnionHeight(d),
            height - getPipeUnionHeight(d) - getPipeUnionPosition(d),
            true);
        pipeUnionTR(d,
            x - getPipeUnionWidth(d),
            y + height - getPipeUnionPosition(d));

        return d;
    };

    //  h-lb-v-tr-h
    //  _______ _
    //           |
    //
    //           |
    //           |
    //           |
    //
    //           |_ ________
    //
    var traceAux_H_LB_V_TR_H = function (d, x, y, width, height, offset) {
        var width1 = (width - getPipeUnionWidth(d) - getPipeUnionPosition(d)) / 2;
        var width2 = width1;
        if (offset) {
            width1 = offset.x - x - getPipeUnionPosition(d);
            width2 = width - width1 - getPipeUnionPosition(d) - getPipeUnionWidth(d);
        }

        var h1 = height - getPipeUnionWidth(d);
        var x1 = x + width1;
        var y1 = y + h1;
        var x2 = x1 + getPipeUnionPosition(d);
        var x3 = x2 + getPipeUnionWidth(d);
        var y3 = y1 + getPipeUnionPosition(d);
        pipeTraceH(d, x, y, width1, true);
        traceAux_LB_V(d, x1, y, h1);
        pipeUnionTR(d, x2, y1);
        pipeTraceH(d, x3, y3, width2, true);
        return d;
    };

    //  h-lb-v-tr-h
    //            _ ________
    //           |
    //
    //           |
    //           |
    //           |
    //
    // _______ _ |
    //
    var traceAux_H_LT_V_TR_H = function (d, x, y, width, height, offset) {
        var width1 = (width - getPipeUnionWidth(d) - getPipeUnionPosition(d)) / 2;
        var width2 = width1;
        if (offset) {
            width1 = offset.x - x - getPipeUnionPosition(d);
            width2 = width - width1 - getPipeUnionPosition(d) - getPipeUnionWidth(d);
        }

        var h1 = height - getPipeUnionHeight(d);
        var x1 = x + width1 + getPipeUnionPosition(d);
        var y1 = y - h1 + getDefaultHeight(d);
        var x2 = x1;
        pipeTraceH(d, x, y, width1, true);
        traceAux_V_LT(d, x1, y1, h1);
        traceAux_BR_H(d, x2, y1, width2, true);
        return d;
    };

    //
    // |
    // |
    //
    // | _ _____ _
    //            |
    //
    //            |
    //            |
    //
    var traceAux_V_TR_H_LB_V = function (d, x, y, width, height, offset) {
        var height1 = offset ?
            offset.y - y - getPipeUnionPosition(d) :
            height / 2 - getPipeUnionPosition(d);
        var height2 = height - height1 - getPipeUnionWidth(d) - getPipeUnionPosition(d);
        pipeTraceV(d, x, y, height1, true);
        traceAux_TR_H_LB(d, x, y + height1, width);
        pipeTraceV(d, x + width, y + height - height2, height2, true);
        return d;
    };

    //
    //           |
    //           |
    //
    //  _ _____ _|
    // |
    //
    // |
    // |
    //
    var traceAux_V_BR_H_LT_V = function (d, x, y, width, height, offset) {
        var height1 = null;
        var height2 = null;
        if (!offset) {
            height1 = height / 2 - getPipeUnionHeight(d);
            height2 = height / 2 - getPipeUnionPosition(d);
        } else {
            height1 = y - offset.y - getPipeUnionHeight(d);
            height2 = height - height1 - getPipeUnionHeight(d) - getPipeUnionPosition(d);
        }

        pipeTraceV(d, x, y - height1, height1, true);
        traceAux_BR_H_LT(d, x, y - height1, width + getDefaultWidth(d));
        pipeTraceV(d, x + width, y - height, height2, true);
        return d;
    };

    //  br-v-tr
    //    _
    //   |
    //
    //   |
    //   |
    //   |
    //
    //  _|
    //
    var traceAux_BR_V_LT = function (d, x, y, height) {
        pipeUnionBR(d, x, y);
        traceAux_V_LT(d, x, y, height);
        return d;
    };

    //  br-v-tr
    //    _
    //   |
    //
    //   |
    //   |
    //   |
    //
    //   |_
    //
    var traceAux_BR_V_TR = function (d, x, y, height) {
        pipeUnionBR(d, x, y);
        traceAux_V_TR(d, x, y, height);
        return d;
    };

    //  lb-v-lt
    //  _
    //   |
    //
    //   |
    //   |
    //   |
    //
    //   |_
    //
    var traceAux_LB_V_TR = function (d, x, y, height) {
        traceAux_LB_V(d, x, y, height);
        pipeUnionTR(d, x, y);
        return d;
    };

    //  lb-v-lt
    //  _
    //   |
    //
    //   |
    //   |
    //   |
    //
    //  _|
    //
    var traceAux_LB_V_LT = function (d, x, y, height) {
        var h1 = height - getPipeUnionHeight(d);
        var y2 = y + h1;
        traceAux_LB_V(d, x, y, h1);
        pipeUnionLT(d, x, y2);
        return d;
    };

    //
    // |_ _____ _|
    //
    var traceAux_TR_H_LT = function (d, x, y, width, height, offset) {
        var width1 = width - getPipeUnionPosition(d);
        traceAux_TR_H(d, x, y, width1);
        pipeUnionLT(d,
            x + width - getPipeUnionPosition(d),
            y + getPipeUnionPosition(d));
        return d;
    };

    //
    // |_ _____ _
    //           |
    //
    var traceAux_TR_H_LB = function (d, x, y, width, height, offset) {
        var width1 = width - getPipeUnionPosition(d);
        traceAux_TR_H(d, x, y, width1);
        pipeUnionLB(d,
            x + width - getPipeUnionPosition(d),
            y + getPipeUnionPosition(d));
        return d;
    };

    //
    //  _ _____ _
    // |         |
    //
    var traceAux_BR_H_LB = function (d, x, y, width) {
        var width1 = width - getPipeUnionWidth(d);
        traceAux_BR_H(d, x, y, width1);
        pipeUnionLB(d,
            x + width1,
            y - getPipeUnionPosition(d) - getPipeUnionHeight(d));
        return d;
    };

    //
    //  _ _____ _|
    // |
    //
    var traceAux_BR_H_LT = function (d, x, y, width) {
        var width1 = width - getPipeUnionWidth(d);
        traceAux_BR_H(d, x, y, width1);
        pipeUnionLT(d,
            x + width1,
            y - getPipeUnionPosition(d) - getPipeUnionHeight(d));
        return d;
    };

    //  v-tr-h
    //   |
    //   |
    //   |
    //   |
    //
    //   |_ ________
    //
    var traceAux_V_TR_H = function (d, x, y, width, height) {
        var y1 = y + height - getPipeUnionHeight(d) + getPipeUnionPosition(d);
        var x1 = x + getPipeUnionWidth(d);
        var w1 = width - getPipeUnionWidth(d);
        traceAux_V_TR(d, x, y, height);
        pipeTraceH(d, x1, y1, w1, true);
        return d;
    };

    //  v-lt-h
    //            |
    //            |
    //            |
    //            |
    //
    // _________ _|
    //
    var traceAux_V_LT_H = function (d, x, y, width, height) {
        var y1 = y + height - getPipeUnionHeight(d) + getPipeUnionPosition(d);
        var x1 = x - width - getPipeUnionPosition(d);
        var w1 = width;
        traceAux_V_LT(d, x, y, height);
        pipeTraceH(d, x1, y1, w1, true);
        return d;
    };

    //  v-lt
    //   |
    //   |
    //   |
    //   |
    //
    //  _|
    //
    var traceAux_V_LT = function (d, x, y, height) {
        var h1 = height - getPipeUnionHeight(d);
        var x1 = x - getPipeUnionPosition(d);
        var y1 = y + h1;
        pipeTraceV(d, x, y, h1, true);
        pipeUnionLT(d, x1, y1);
        return d;
    };

    //  v-tr
    //   |
    //   |
    //   |
    //   |
    //
    //   |_
    //
    var traceAux_V_TR = function (d, x, y, height) {
        var h1 = height - getPipeUnionHeight(d);
        var y2 = y + h1;
        pipeTraceV(d, x, y, h1, true);
        pipeUnionTR(d, x, y2);
        return d;
    };

    //  br-v-h
    //    _ __________
    //   |
    //
    //   |
    //   |
    //   |
    //
    var traceAux_BR_V_H = function (d, x, y, width, height) {
        var x1 = x + getPipeUnionWidth(d);
        var w1 = width - getPipeUnionWidth(d);
        traceAux_BR_V(d, x, y, height);
        pipeTraceH(d, x1, y, w1, true);
        return d;
    };

    //  br-v
    //    _
    //   |
    //
    //   |
    //   |
    //   |
    //
    var traceAux_BR_V = function (d, x, y, height) {
        var y1 = y + getPipeUnionHeight(d);
        var h1 = height - getPipeUnionHeight(d);
        pipeUnionBR(d, x, y);
        pipeTraceV(d, x, y1, h1, true);
        return d;
    };

    //  lb-v
    //  _
    //   |
    //
    //   |
    //   |
    //   |
    //
    var traceAux_LB_V = function (d, x, y, height) {
        var x1 = x + getPipeUnionPosition(d);
        var y1 = y + getPipeUnionHeight(d);
        var h1 = height - getPipeUnionHeight(d);
        pipeUnionLB(d, x, y);
        pipeTraceV(d, x1, y1, h1, true);
        return d;
    };

    //  br-h
    //   _ _______
    //  |
    //
    var traceAux_BR_H = function (d, x, y, width) {
        var y1 = y - getPipeUnionHeight(d);
        pipeUnionBR(d, x, y1);
        pipeTraceH(d,
            x + getPipeUnionWidth(d),
            y1,
            width - getPipeUnionWidth(d),
            true);
        return d;
    };

    //  tr-h
    //
    //  |_ _______
    //
    var traceAux_TR_H = function (d, x, y, width) {
        pipeUnionTR(d,
            x,
            y);
        pipeTraceH(d,
            x + getPipeUnionWidth(d),
            y + getPipeUnionPosition(d),
            width - getPipeUnionWidth(d),
            true);
        return d;
    };

    //  h-lb
    //  _______ _
    //           |
    //
    var traceAux_H_LB = function (d, x, y, width) {
        var w1 = width - getPipeUnionWidth(d);
        pipeTraceH(d,
            x,
            y,
            w1,
            true);
        pipeUnionLB(d,
            x + w1,
            y);

        return d;
    };

    //  h-lt
    //
    //  ______ _|
    //
    var traceAux_H_LT = function (d, x, y, width) {
        pipeTraceH(d,
            x,
            y + getPipeUnionPosition(d),
            width - getPipeUnionPosition(d),
            true);
        pipeUnionLT(d,
            x + width - getPipeUnionPosition(d),
            y);
        return d;
    };

    // _
    //  |
    //
    var pipeUnionLB = function (d, x, y) {
        d.components.push(addSubComponents(d));
        d.components[d.components.length - 1].pipeType = hmi.constant.pipeType.unionLB;
        d.components[d.components.length - 1].key += 't' + hmi.constant.pipeType.unionLB;
        d.components[d.components.length - 1].x = x;
        d.components[d.components.length - 1].y = y;
        updatePipeTransform(d.components[d.components.length - 1]);
        return d;
    };

    //  _|
    //
    var pipeUnionLT = function (d, x, y) {
        d.components.push(addSubComponents(d));
        d.components[d.components.length - 1].pipeType = hmi.constant.pipeType.unionLT;
        d.components[d.components.length - 1].key += 't' + hmi.constant.pipeType.unionLT;
        d.components[d.components.length - 1].x = x;
        d.components[d.components.length - 1].y = y;
        updatePipeTransform(d.components[d.components.length - 1]);
        return d;
    };

    //  _
    // |
    //
    var pipeUnionBR = function (d, x, y) {
        d.components.push(addSubComponents(d));
        d.components[d.components.length - 1].pipeType = hmi.constant.pipeType.unionBR;
        d.components[d.components.length - 1].key += 't' + hmi.constant.pipeType.unionBR;
        d.components[d.components.length - 1].x = x;
        d.components[d.components.length - 1].y = y;
        updatePipeTransform(d.components[d.components.length - 1]);
        return d;
    };

    //  |_
    //
    var pipeUnionTR = function (d, x, y) {
        d.components.push(addSubComponents(d));
        d.components[d.components.length - 1].pipeType = hmi.constant.pipeType.unionTR;
        d.components[d.components.length - 1].key += 't' + hmi.constant.pipeType.unionTR;
        d.components[d.components.length - 1].x = x;
        d.components[d.components.length - 1].y = y;
        updatePipeTransform(d.components[d.components.length - 1]);
        return d;
    };

    //
    // ------
    //
    var pipeTraceH = function (d, x, y, width, movable) {
        d.components.push(addSubComponents(d));
        d.components[d.components.length - 1].movable = movable || false;
        d.components[d.components.length - 1].x = x;
        d.components[d.components.length - 1].y = y;
        d.components[d.components.length - 1].width = width;
        d.components[d.components.length - 1].height = defaultHeight;
        updatePipeTransform(d.components[d.components.length - 1]);
        return d;
    };

    //
    // |
    // |
    // |
    //
    var pipeTraceV = function (d, x, y, height, movable) {
        d.components.push(addSubComponents(d));
        d.components[d.components.length - 1].movable = movable || false;
        d.components[d.components.length - 1].x = x;
        d.components[d.components.length - 1].y = y;
        d.components[d.components.length - 1].height = height;
        d.components[d.components.length - 1].width = defaultWidth;
        d.components[d.components.length - 1].alignment = hmi.constant.alignment.vertical;
        updatePipeTransform(d.components[d.components.length - 1]);
        return d;
    };

    var getOffset = function (d, index, outLimit, oldOffset) {
        var offset = null;
        var i = 0;
        if (d.offsets && d.offsets.length > 0) {
            do {
                if (d.offsets[i].index === index) {
                    offset = d.offsets[i];
                    if (outLimit(d.offsets[i])) {
                        if (oldOffset && oldOffset[i]) {
                            d.offsets[i] = oldOffset[i];
                            offset = oldOffset[i];
                        } else {
                            offset = null;
                        }
                    }
                }
                i++;
            } while (offset === null && i < d.offsets.length);
        }

        return offset;
    };

    var updatePipeTransform = function (d) {
        if (d.pipeType === hmi.constant.pipeType.line && d.alignment === hmi.constant.alignment.horizontal) {
            d.transformWidth = d.width / defaultWidth;
            d.transformHeight = d.pipeSize;
        }
        if (d.pipeType === hmi.constant.pipeType.line && d.alignment === hmi.constant.alignment.vertical) {
            d.transformWidth = d.pipeSize;
            d.transformHeight = d.height / defaultHeight;
        }
        if (d.pipeType !== hmi.constant.pipeType.line) {
            d.transformWidth = d.pipeSize;
            d.transformHeight = d.pipeSize;
        }

        d.transform = 'translate(' + d.x + ',' + d.y + ') ' +
            'scale(' + d.transformWidth + ',' + d.transformHeight + ')';
    };

    var selectComponent = function () {
        d3.select(selectTarget)
            .style('stroke', color.select);
    };

    var unSelectComponent = function () {
        d3.select(selectTarget).attr("pointer-events", "all")
            .style('stroke', null);
    };

    // todo this is temporal the position will come from component
    var updatePipePosition = function (link) {
        switch (link.pPipe) {
            case hmi.constant.pipeCPosition.R:
                link.xPipe = link.x + link.width;
                link.yPipe = link.y + link.height - componentPipePosition;
                break;
            case hmi.constant.pipeCPosition.L:
                link.xPipe = link.x;
                link.yPipe = link.y + link.height - componentPipePosition;
                break;
            case hmi.constant.pipeCPosition.T:
                link.xPipe = link.x + link.width / 2 - 12.5;
                link.yPipe = link.y;
                break;
            case hmi.constant.pipeCPosition.B:
                link.xPipe = link.x + link.width / 2 - 12.5;
                link.yPipe = link.y + link.height;
                break;
        }
    };

    /* var updateLinkPipePosition = function (link1, link2) {
        // link1.pPipe = tracerMode.link1;
        updatePipePosition(link1);
        // link2.pPipe = tracerMode.link2;
        updatePipePosition(link2);
    }; */

    function initSymbols() {
        svgPipeLine = hmi.symbols.svgPipeLine;
        svgPipeLineV = hmi.symbols.svgPipeLineV;
        svgPipeUnionBR = hmi.symbols.svgPipeUnionBR;
        svgPipeUnionLB = hmi.symbols.svgPipeUnionLB;
        svgPipeUnionTR = hmi.symbols.svgPipeUnionTR;
        svgPipeUnionLT = hmi.symbols.svgPipeUnionLT;
    }

    function pipe(selection) {
        selection.each(function (data) {

            allData = data;
            var container = d3.select(this).data(data);

            initSymbols();
            pipe.container = this;

            container.selectAll('g.nv-group-pipe')
                .data([data])
                .enter()
                .append('g')
                //.insert('g', ':first-child')
                .attr('class', 'nv-group-pipe');

            var gEnter = d3.select('g.nv-group-pipe')
                .selectAll('g.nv-pipe')
                .data(data, function (item) {
                    return item.key;
                });
            var gComponent = gEnter
                .enter()
                .append('g')
                .attr('class', 'nv-pipe')
                .attr('id', function (d) {
                    return d.id;
                });

            if (svgPipeLine && svgPipeLineV && svgPipeUnionBR && svgPipeUnionLB &&
                svgPipeUnionTR && svgPipeUnionLT) {
                initializeCanvasObjects(gComponent, gEnter);
            }

            gEnter.exit().remove();
            pipe.update = function () {
                container.call(pipe);
            };

        });

        return pipe;
    }

    function updateExitsPipe(d) {
        var linkData = allData.filter(function (item) {
            return (item.links.link1.id === d.linkId || item.links.link2.id === d.linkId) && item.links.link1.id && item.links.link2.id;
        });
        linkData.forEach(function (item) {
            if (item.links.link1.id === d.linkId) {
                item.links.link1.x = d.x;
                item.links.link1.y = d.y;
                item.links.link1.xPipe = d.positionPipe[item.links.link1.pPipe].x;
                item.links.link1.yPipe = d.positionPipe[item.links.link1.pPipe].y;
                item.links.link1.width = d.width;
                item.links.link1.height = d.height;
                // updatePipePosition(item.links.link1);
            }
            else if (item.links.link2.id === d.linkId) {
                item.links.link2.x = d.x;
                item.links.link2.y = d.y;
                item.links.link2.xPipe = d.positionPipe[item.links.link2.pPipe].x;
                item.links.link2.yPipe = d.positionPipe[item.links.link2.pPipe].y;
                item.links.link2.width = d.width;
                item.links.link2.height = d.height;
                // updatePipePosition(item.links.link2);
            }
            item.offsets = [];
            item = pipeTrace(item);
            var componentIndex = allData.findIndex(function (element) {
                return element.id === item.id;
            });
            if (componentIndex !== -1) {
                var component = allData[componentIndex];
                dispatch.componentChange({
                    component: component
                });
            }
        });
    }

    pipe.updateChangeLink = function (d) {
        if (pendingPipe && pendingPipe.links.link1 && pendingPipe.links.link1.id === d.linkId) {
            pendingPipe.links.link1.x = d.x;
            pendingPipe.links.link1.y = d.y;
            pendingPipe.links.link1.xPipe = d.positionPipe[pendingPipe.links.link1.pPipe].x;
            pendingPipe.links.link1.yPipe = d.positionPipe[pendingPipe.links.link1.pPipe].y;
            pendingPipe.links.link1.width = d.width;
            pendingPipe.links.link1.height = d.height;
        }
        if (pendingPipe && pendingPipe.links.link2 && pendingPipe.links.link2.id === d.linkId) {
            pendingPipe.links.link2.x = d.x;
            pendingPipe.links.link2.y = d.y;
            pendingPipe.links.link2.xPipe = d.positionPipe[pendingPipe.links.link2.pPipe].x;
            pendingPipe.links.link2.yPipe = d.positionPipe[pendingPipe.links.link2.pPipe].y;
            pendingPipe.links.link2.width = d.width;
            pendingPipe.links.link2.height = d.height;
        }
        updateExitsPipe(d);
    }

    pipe.Change = function pipe(d) {
        if (d) {
            if (pendingPipe) {
                if (!pendingPipe.links.link1) {
                    pendingPipe.links.link1 = {};
                    pendingPipe.links.link1.id = d.linkId;
                    pendingPipe.links.link1.x = d.x;
                    pendingPipe.links.link1.y = d.y;
                    pendingPipe.links.link1.xPipe = d.positionPipe[d.connectionPosition].x;
                    pendingPipe.links.link1.yPipe = d.positionPipe[d.connectionPosition].y;
                    pendingPipe.links.link1.pPipe = d.connectionPosition;
                    pendingPipe.links.link1.width = d.width;
                    pendingPipe.links.link1.height = d.height;
                } else if (!pendingPipe.links.link2) {
                    if (pendingPipe.links.link1.id == d.linkId) return;
                    pendingPipe.links.link2 = {};
                    pendingPipe.links.link2.id = d.linkId;
                    pendingPipe.links.link2.x = d.x;
                    pendingPipe.links.link2.y = d.y;
                    pendingPipe.links.link2.xPipe = d.positionPipe[d.connectionPosition].x;
                    pendingPipe.links.link2.yPipe = d.positionPipe[d.connectionPosition].y;
                    pendingPipe.links.link2.pPipe = d.connectionPosition;
                    pendingPipe.links.link2.width = d.width;
                    pendingPipe.links.link2.height = d.height;
                    pendingPipe = pipeTrace(pendingPipe);
                    var pendingPipeCopy = JSON.parse(JSON.stringify(pendingPipe));
                    pendingPipe = null;
                    hmi.utils.addPendingPipe(null);
                    dispatch.addCompletePipe({
                        pipe: pendingPipeCopy
                    });
                }
            } else {
                updateExitsPipe(d);
            }
        }
    };

    pipe.dispatch = dispatch;

    pipe.options = hmi.utils.optionsFunc.bind(pipe);

    pipe._calls = new function () {
        this.getPendingObject = function () {
            var idNumber = 1;
            var temp = allData[allData.length - 1];
            if (temp) {
                idNumber = parseInt(temp.id.match(/\d+/g)[0]) + 1;
            }
            var result = {
                id: 'pipe-' + idNumber,
                key: 'pipe-' + idNumber,
                index: idNumber,
                groupType: groupType,
                type: type,
                pipeSize: pipeSize,
                html: null,
                transform: null,
                links: { link1: null, link2: null },
                offsets: [],
                components: [],
                data: {
                    value: 25
                },
                pipeColor: null
            };

            // result.components.push(addSubComponents(result, null));
            pendingPipe = result;

            // dispatch.pendingPipeChange({
            //     pipe: result
            // });

            return result;
        };
        this.getObject = function (data) {
            var idNumber = 1;
            var temp = allData[allData.length - 1];
            if (temp) {
                idNumber = parseInt(temp.id.match(/\d+/g)[0]) + 1;
            }
            var result = null;
            if (!data) {
                result = {
                    id: 'pipe-' + idNumber,
                    key: 'pipe-' + idNumber,
                    index: idNumber,
                    groupType: groupType,
                    type: type,
                    x: 0,
                    y: 0,
                    width: null,
                    height: null,
                    pipeTracerMode: null,
                    pipeSize: pipeSize,
                    movable: undefined,
                    html: null,
                    transform: null,
                    links: { link1: null, link2: null },
                    offsets: [],
                    components: [],
                    data: {
                        value: 0
                    }
                };

                //result.components.push(addSubComponents(result, null));
            } else {
                result = {
                    id: data.id,
                    key: data.key,
                    index: data.index,
                    groupType: groupType,
                    type: type,
                    x: data.x,
                    y: data.y,
                    width: data.width,
                    height: data.height,
                    pipeTracerMode: data.pipeTracerMode,
                    pipeSize: data.pipeSize,
                    movable: data.movable,
                    html: data.html,
                    transform: data.transform,
                    links: data.links,
                    offsets: data.offsets,
                    components: [],
                    data: {
                        value: 25
                    }
                };
                data.components.forEach(function (item) {
                    result.components.push(addSubComponents(result, item));
                });

            }

            return result;
        };
        this.updateConfig = function (value, data) {
            value.pipeColor = data.config.pipeColor || null;
            value.pipeSize = data.config.pipeSize || 1;
            pipeSize = value.pipeSize;
            value.components.forEach(function (item) {
                item.pipeColor = data.config.pipeColor || null;
                item.pipeSize = data.config.pipeSize || 1;
                if (data.config.pipeSize) {
                    hmi.brodcast.pipeSizeChange({
                        pipeSize: data.config.pipeSize
                    });
                }

                //updatePipeTransform(item);
            });
            // todo this is temporal the position will come from component
            tracerMode = (value.config && value.config.tracerMode) ? value.config.tracerMode : tracerMode;
            pipeTrace(value);
            return value;
        };

        this.unSelectComponent = unSelectComponent;
        this.getPipeUnionWidth = getPipeUnionWidth;
        this.getPipeUnionHeight = getPipeUnionHeight;
        this.getDefaultHeight = getDefaultHeight;
        this.getDefaultWidth = getDefaultWidth;
    };

    pipe._options = Object.create({}, {
        // simple options, just get/set the necessary values
        showMode: {
            get: function () {
                return showMode;
            },
            set: function (_) {
                showMode = _;
            }
        },
        designMode: {
            get: function () {
                return designMode;
            },
            set: function (_) {
                designMode = _;
            }
        },
        availableWidth: {
            get: function () {
                return availableWidth;
            },
            set: function (_) {
                availableWidth = _;
            }
        },
        availableHeight: {
            get: function () {
                return availableHeight;
            },
            set: function (_) {
                availableHeight = _;
            }
        },
        valueFormat: {
            get: function () {
                return valueFormat;
            },
            set: function (_) {
                valueFormat = _;
            }
        },
        pipeSize: {
            get: function () {
                return pipeSize;
            },
            set: function (_) {
                pipeSize = _;
            }
        },
    });

    hmi.utils.initOptions(pipe);

    return pipe;
};


